{
  "country_code": "1",
  "toMiles": true,
  "neighborhoods": false,
  "currency_config_up": "USD",
  "masks": {
    "phone": "(000) 0000-0000",
    "cell": "(000) 000-0000",
    "secret_number": "000-00-0000",
    "secret_number_company": "00-000000/0000-00",
    "ssn_mask": "000-00-0000",
    "zipcode": "00000",
    "date_mask": "MM/dd/yyyy",
    "date_mask_format_m": "DD/MM/YYYY",
    "date_mask_two": "MM/dd",
    "mi": "MI",
    "states": [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY"
    ]
  },
  "sort_by": "Sort by",
  "sale_without_registration": "Sale without registration",
  "i_dont_need_indentify_client": "I don't need to identify the client",
  "closing": "Closing",
  "uf": "States",
  "contact": "Contact",
  "favorite_card_comment": "Ex: My favorite card",
  "finalize_order_comment": "Finalize Order",
  "goodbye": "goodbye!",
  "possibles": "possibles",
  "opened": "opened",
  "are_you_here": "are you here?",
  "no_categories_available_at_moment": "No categories available for table-type orders at the moment.",
  "check_admin_panel_categories_active": "Check the admin panel to ensure that categories are active and available for table-type orders.",
  "cart_empty": "Cart Empty",
  "optional": "optional",
  "add_comment": "+Add",
  "obs": "Observations",
  "confirm_send_to_whatsapp": "Do you confirm to send the order via WhatsApp?",
  "send_message": "Send Message",
  "dont_send_message": "Don't send message",
  "my_orders": "my orders",
  "tax_and_time_of_shipping": "tax and time of shipping",
  "scheduling": "Packages",
  "scheduling2": "Scheduling",
  "package_s": "Packages",
  "close_order": "close order",
  "verify": "verify",
  "add_more_items": "add more items",
  "next": "Next",
  "edit_item": "edit item",
  "select_shipoing": "Select Shipping",
  "take_out": "take out",
  "cupom": "coupon",
  "your_location": "your location. drag the marker to adjust.",
  "active_your_cupom": "active your coupon",
  "code_of_cupom": "code of coupon",
  "total": "total",
  "select_the_form_of_shipping": "select the form of shipping",
  "mandatory": "mandatory",
  "go_to_payment": "go to payment",
  "pay_on_app": "pay on app",
  "pay_on_shippingg": "pay on shipping",
  "my_cards": "my cards",
  "discont": "Discount",
  "payment_in_comment": "Payment in",
  "i_need_transhipment": "need transhipment to",
  "i_not_need_transhipment": "Don't Need Transhipment",
  "adjust_location": "Adjust Location",
  "secret_number_on_note": "SSN on note",
  "search_products_by_name_or_description": "Search Products by Name or Description",
  "outside_the_coverage_area": "outside the coverage area",
  "unavilable": "Unavilable",
  "avaible": "avaible",
  "product_unavilable": "product unavilable",
  "unavilable_amount": "unavilable amount",
  "table_s": "tables",
  "discont_of": "discont of",
  "free_freight": "Free Freight",
  "free_freight_comment": "Free Freight",
  "free_comment_up": "FREE",
  "covered_address": "Covered Address",
  "send_order": "send order",
  "you_are_blocked": "you are blocked",
  "enter_your_cell": "enter your cell",
  "enter_your_email": "enter your email",
  "enter_your_address": "enter your address",
  "enter_you_ddd": "enter your cell with DDD",
  "minimum_unconceived_value": "minimum unconceived value",
  "finish_payment_pix": "finish payment pix",
  "finish_payment": "finish payment",
  "payment_online": "payment online",
  "payment_offline": "payment offline",
  "add_new_card": "add new card",
  "pay_on_delivery": "pay on delivery",
  "i_need_change_for": "i need change for",
  "i_dont_need_change": "i don't need change",
  "send_the_receipt": "send the recepit to our whatsapp to expedite your service",
  "copy_key": "copy key",
  "select_the_flag": "select the flag",
  "select_the_flag_comment": "Select the Flag",
  "cpf_on_the_receipt": "SSN on the receipt",
  "cpf_cnpj_invalid": "Invalid SSN",
  "how_to_pay_with_pix": "How to pay with PIX",
  "enter_cpf_generate_pix": "Enter your SSN to generate a PIX key",
  "enter_cpf": "Enter your SSN",
  "enter_a_valid_cpf": "Enter a valid SSN",
  "order_pending_payment": "order pending payment",
  "generate_pix_key": "Generate PIX key",
  "pix_copy_paste": "PIX Copy and paste",
  "copy_code": "copy coding",
  "pix_key_expired": "Your PIX key has expired. Click the button to generate a new code",
  "paste_this_code_your_bank": "Past this code in the Copy and Paste PIX option your bank",
  "verify_pix_payment": "Verify PIX Payment",
  "card_details": "card details",
  "name_on_the_card": "name on the card",
  "card_number": "card number",
  "expiry": "expiry",
  "card_nickname": "card nickname (optional)",
  "billing_adress": "billing adress",
  "zip_code_not_found": "ZIP Code not found",
  "adress_line_2": "adress line 2 (optional)",
  "order_will_be_delivered": "order will be delivered to",
  "to_consult": "to consult",
  "flavors_comment": "Flavors",
  "flavor_comment": "Flavor",
  "crust": "crust",
  "general_toppings": "general toppings",
  "single_crust": "single crust",
  "message_cvv_payment": "Enter the CVV code from your card to complete the payment",
  "code_back_of_your_card": "this code is located on the back of your card",
  "complete_payment": "complete payment",
  "what_card_nickname": "what is this card's nickname",
  "what_your_name": "What's your name",
  "open_new_order": "Open new order",
  "enter_name_your_order": "Enter a name for your order",
  "select_order": "Select an order",
  "addition": "Addition",
  "use_cashback": "use cashback balance",
  "balance": "balance",
  "indentify_yourself": "indentify yourself",
  "whatsapp_number": "whatsapp number",
  "date_of_birth": "date of birth",
  "place_order_necessary_information": "to place the order, it is necessary to fill out the above information",
  "order_slip_s": "Order slips",
  "no_active_orders": "no active orders",
  "order_sucess": "order placed successfully",
  "send_confirmation_whatsapp": "send confirmation via whatsapp",
  "select_delivery_date": "select a delivery date",
  "time_zone_is_different": "We have identified that your time zone is different from the establishment's time zone. Your corresponding receiving time will be shown next to the time",
  "delivery_time_between": "choose a delivery time between the periods",
  "delivery_for_order": "choose a delivery for your order",
  "establishment_notes": "establishment notes",
  "no_more_avaible_slots_for_orders": "we have no more avaible slots for orders. please contact our establishment",
  "contact_establishment": "contact the establishment",
  "no_slots_avaible_for_orders_on_that_day": "we have no more slots avaible for orders on that day",
  "please_select_another_date": "please select another dater.",
  "continue": "continue",
  "last_orders": "Last Orders",
  "view_order": "view order",
  "edit_addresses": "edit addresses",
  "addresses": "addresses",
  "add_new_addresses": "add new addresses",
  "create_address_or_use_list_below": "create a new address or use the list below",
  "more_information": "more information",
  "notification_permissions": "to recive notifications, you need to grant notification permissions on your device.",
  "opening_hours": "opening hours",
  "from_de": "From",
  "to": "to",
  "pay_online": "pay online",
  "choose_this_option_secure_payment": "choose this option to make a secure payment through our online system.",
  "choose_option_receiving": "prefer to pay upon receiving your order? choose this option.",
  "acess_your_payment_app": "acess your payment app",
  "qrcode_copy_paste_payment": "scan the qr code or copy and paste the payment code",
  "pay_credited_instantly": "pay and it will be credited instantly",
  "enter_your_cpf": "Enter your SSN",
  "local_pickup": "local pickup",
  "payment_still_pending": "payment still pending. please try again.",
  "confirmation_is_taking_too_long": "if the confirmation is taking too long, click the button to proceed.",
  "use_delivery_address": "use delivery address",
  "state": "state",
  "cash_payment": "cash payment",
  "payment_meal_voucher": "payment by meal voucher.",
  "payment_food_voucher": "payment by food voucher",
  "receipt_to_our_whatsapp": "send the receipt to our whatsapp to expedite your service",
  "total_to_transfer": "total to transfer",
  "type_of_key": "type of key",
  "save_future_purchases": "save for future purchases",
  "finalize_order": "finalize order",
  "add_on": "Add-on",
  "error_generating_qrcode": "Error generating QR code. Please try again.",
  "payment_not_detected_check_banking": "Payment not detected. Please check your banking app.",
  "error_processing_payment": "Error processing the payment, please try again.",
  "error_creating_customer": "Error creating customer. Please try again.",
  "choose_single_crust": "choose the single crust",
  "choose_single_crust_comment": "Choose Single Crust",
  "choose_crust_comment": "Choose Crust",
  "crust_without_filling": "crust without filling",
  "choose_the": "choose the",
  "choose_the_o": "choose the",
  "complete_order_mandotory": "complete your order with the mandatory items",
  "no_orders_moment": "no orders at the moment",
  "fee_comment": "Fee",
  "pickup_only": "pickup only",
  "loading_dates": "loading dates",
  "choose_date": "choose a date",
  "see_full_list": "click here to see the full list of products",
  "no_products_found": "sorry, no products found",
  "size_unavilable": "size unavailable",
  "edit_notes": "edit notes",
  "remove_item": "remove item",
  "point_camera_qrcode": "please point your camera at the QRCode on the table where you wish to place your order",
  "order_status": "order status",
  "in_preparation": "in preparation",
  "canceled": "canceled",
  "order_received": "order received",
  "pending_payment": "pending payment",
  "order_approved": "order approved",
  "order_preparation": "order in preparation",
  "order_canceled": "order canceled",
  "order_out_for_delivery": "order is out for delivery",
  "order_ready_for_pickup": "order ready for pickup",
  "send_order_whatsapp": "send order via whatsapp",
  "reference_point": "Reference Point",
  "house_corner": "House corner",
  "address_complement": "Address Complement",
  "block_apt": "Block, Apt",
  "ave": "Ave. Times Square",
  "date_usa": "mm/dd/yyyy",
  "choose_time": "Choose a Time",
  "minimum_quantity": "Minimum quantity",
  "maximum_quantity": "Maximum quantity",
  "repeat_order": "repeat order",
  "pick_up_counter": "Pick up at the Counter",
  "counter_and_delivery": "Counter/Delivery",
  "discount_comment": "Discount",
  "discount_of": "discount of",
  "applied": "applied",
  "change_address": "change address",
  "message_no_costumer_selected": "No customer selected for this order. Please search for a registered customer or register a new one to proceed.",
  "search_customer": "search customer",
  "add_customer": "Add Customer",
  "outside_service_area": "OUTSIDE THE SERVICE AREA",
  "free_comment": "Free",
  "activate_coupon_comment": "Activate Your Coupon",
  "order_type": "order type",
  "place_order": "place order",
  "open_register": "open register",
  "initial_balance": "Initial Balance $",
  "initial_balance_n": "Initial Balance",
  "income": "income",
  "cash_register_status": "cash register status",
  "cash_outflow": "cash outflow",
  "close_cash_register": "close cash register",
  "cash_balance": "cash balance",
  "cashier_balance": "cashier balance",
  "final_balance": "final balance",
  "new_order": "New Order",
  "create_order_slip": "create order slip",
  "change_tables": "change tables",
  "table_change": "table change",
  "print_table": "print table",
  "close_table": "close table",
  "client_comment": "Customer",
  "no_registred_address": "no registred address",
  "none": "none",
  "search_name_comment": "Search by code or name",
  "search_flavor_comment": "Search by code or flavor",
  "waiting_service": "waiting for service",
  "pause_comment": "Pause",
  "unpause_comment": "Unpause",
  "order_buy": "order",
  "order_the_table": "order at the table",
  "registration_comment": "Registration",
  "change_comment": "Change",
  "one_more_comment": "One more",
  "customer": "customers",
  "customer_name_comment": "Customer name",
  "customer_last_name_comment": "Customer last name",
  "email_example_comment": "customer@example.com",
  "ssn_model_comment": "000-00-0000",
  "number_model_comment": "(000)000-0000",
  "order_by": "Order by",
  "delivery_address": "Delivery Address",
  "number_comment": "Number",
  "no_number": "no number",
  "dont_know_my_zip": "i don't know my ZIP",
  "other_s": "Others",
  "deliver_this_address": "Deliver to This Address",
  "out_coverage_area": "out of coverage area",
  "finalize_appointment": "finalize appointment",
  "return_cancel": "Return/Cancel",
  "return": "Return",
  "remaining": "remaining",
  "fee_discount": "Fee/Discount",
  "how_pay_pix": "How To Pay With PIX",
  "step": "step",
  "payment_deadline": "the payment deadline is in",
  "select_comment": "Select",
  "call_back_house": "Ex: Call at The Back House",
  "change_for_comment": "Change For",
  "for": "for",
  "out_for_delivery": "out for delivery",
  "waiting_for_pickup": "waiting for pickup",
  "add_flavor": "add flavor",
  "your_flavor": " your flavor",
  "choose": "Choose",
  "choose_up_to": "Choose up to",
  "selected_date_is_earlier": "the selected date is earlier than the current date",
  "register_closing": "cash register closing",
  "confirm_register_closing": "confirm cash register closing",
  "closing_insert_following": "during the closing, insert the following amounts into your cash drawer",
  "register_login": "cash register login",
  "deposit": "Deposit",
  "purpose": "purpose",
  "list": "list",
  "make_payment": "make payment",
  "uncancel_order": "uncancel order",
  "order_amount": "total order amount",
  "print_the": "print the",
  "next_flavor_comment": "Next Flavor",
  "choose_flavor_comment": "Choose a Flavor",
  "quantity_unavaible": "Quantity Unavaible",
  "complete_toppings_comment": "Complete Toppings",
  "out_stock_toppings_comment": "Out of Stock Toppings",
  "in_stock_comment": "In Stock",
  "the_flavors_comment": "the Flavors",
  "the_crust_comment": "the Crust",
  "the_toppings_comment": "the Toppings",
  "mandatory_to_choose": "it is mandatory to choose",
  "time_closed_comment": "Time Closed!",
  "change_less_purchase_comment": "Change less than the purchase amount",
  "free_shipping_comment": "FREE SHIPPING",
  "consult_comment": "Consult",
  "location_comment": "Location",
  "paid_online_comment": "Paid Online",
  "track_order": "Track order",
  "street": "Street",
  "order_comment": "Order",
  "schedule": "Schedule",
  "closed_orders": "Closed Orders",
  "scheduling_closed": "Scheduling Closed",
  "order_name": "order name",
  "no_product_found": "no product found",
  "items_found": "items found",
  "mandatory_items": "mandatory items",
  "minimum": "minimum",
  "advance": "Advance",
  "loading_page": "Loading...",
  "enter_city": "Enter the city",
  "select_city": "Select the city",
  "enter_neighborhood": "Enter the neighborhood",
  "select_neighborhood": "Select the neighborhood",
  "enter_street_name": "Enter the street name",
  "coupon_only_used_purchases": "This coupon can only be used on purchases starting from",
  "discount_coupon_greater_total": "The discount on the coupon is greater than the total amount!",
  "add_to_order": "Add to Order",
  "data_print": "Date print",
  "generate_fiscal_note": "Issue Invoice",
  "alert": {
    "unable_to_read": "Unable to read your location, please check if location services are not blocked.",
    "address_covarage_area": "Your address is outside our coverage area!",
    "register_open_24": "There is a cash register open for more than 24 hours, and it will be closed.",
    "table_desactived": "Sorry, this table is currently desactived",
    "moment_table_not_avaible": "At the moment, this table is not avaible for new orders",
    "table_not_avaible_new_orders": "At the moment, this table is not available for new orders.",
    "order_already_been_completed": "The previous order has already been completed. Are you still at the restaurant, or would you like to place a new order for delivery?",
    "at_the_table": "I'm at the table",
    "deliver_order": "Deliver order",
    "not_belong_this_table": "This order does not belong to this table.",
    "store_closed": "STORE CLOSED!",
    "not_minimum_value": "Your order did not meet the minimum value of",
    "failed_validate_coupon": "Failed to validate coupon, please check your connection!",
    "amount_not_include_delivery_fee": "This total amount does not include the delivery fee.",
    "coupon_used_starting_from": "This coupon can only be used for purchases starting from",
    "closed_delivery": "CLOSED FOR DELIVERY",
    "unable_create_customer": "Unable to create customer. Please try again.",
    "selected_date_earlier_choose_later_date": "The selected date is earlier than the current date, please choose a later date",
    "try_again_moment": "Something unexpected happened, please try again in a moment.",
    "error_generate_qrcode": "Unable to generate QR Code. Please try again.",
    "payment_not_detected": "Payment not detected. Please check your bank app.",
    "reloaded_page_message": "The page needs to be reloaded!",
    "name_and_last_name_and_phone_required": "Name, last name and phone number are required",
    "enter_your_details": "Enter your details",
    "enter_your_name": "Enter your name",
    "enter_your_whatsapp": "Enter your Whatsapp",
    "enter_your_date_of_birth": "Enter your date of birth",
    "review_change_amount": "Review the Change Amount!",
    "no_internet_connection": "No Internet Connection",
    "add_another_card": "Add another card",
    "zip_invalid": "Zip code is invalid"
  },
  "calendar": {
    "weekdays": [
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat",
      "Sun"
    ],
    "months": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "Agust",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  "timezones": [
    {
      "label": "New York",
      "value": "America/New_York"
    },
    {
      "label": "Detroit",
      "value": "America/Detroit"
    },
    {
      "label": "Louisville",
      "value": "America/Louisville"
    },
    {
      "label": "Indianapolis",
      "value": "America/Indianapolis"
    },
    {
      "label": "Chicago",
      "value": "America/Chicago"
    },
    {
      "label": "Indiana Knox",
      "value": "America/Indiana/Knox"
    },
    {
      "label": "Menominee",
      "value": "America/Menominee"
    },
    {
      "label": "Winnipeg",
      "value": "America/Winnipeg"
    },
    {
      "label": "Denver",
      "value": "America/Denver"
    },
    {
      "label": "Phoenix",
      "value": "America/Phoenix"
    },
    {
      "label": "Los Angeles",
      "value": "America/Los_Angeles"
    },
    {
      "label": "Vancouver",
      "value": "America/Vancouver"
    },
    {
      "label": "Anchorage",
      "value": "America/Anchorage"
    },
    {
      "label": "Juneau",
      "value": "America/Juneau"
    },
    {
      "label": "Honolulu",
      "value": "Pacific/Honolulu"
    },
    {
      "label": "Puerto Rico",
      "value": "America/Puerto_Rico"
    },
    {
      "label": "Guam",
      "value": "Pacific/Guam"
    }
  ],
  "unitSystem": "imperial",
  "distanceinkmto": "Distance in miles to",
  "distance": "Distance",
  "distance_added_successfully": "Distance added successfully",
  "the_distance_already_exists": "This distance already exists",
  "distance_deleted_successfully": "Distance deleted successfully",
  "update_shipping": "Update Shipping",
  "tobeconfirmed": "To be confirmed",
  "km": "Miles",
  "time": "Time",
  "coin": "$",
  "currency_config": "usd",
  "ddi": "1",
  "date_format": "MM/dd/yyyy",
  "date_format_v2": "MM/dd",
  "order_updated_at": "Updated at",
  "welcome": "Welcome",
  "description": "Description",
  "orders": "Orders",
  "order": "Order",
  "order_management": "Order Management",
  "new_feature": "New Feature",
  "work_waiters_taking": "Do you work with waiters taking orders?",
  "register_you_waiters_quickly": "Then register your waiters and quickly place orders.",
  "dont_work_waiters": "I don't work with waiters",
  "register_waiters": "Register my waiters",
  "orders_were_not_received": "Orders that were not received.",
  "orders_appointments": "Orders/Appointments",
  "efficiency": "Efficiency",
  "incredible_agility": "Incredible agility in managing tables and orders like never seen before; this system is everything you’ve always dreamed of to earn more money and organize your restaurant.",
  "automation": "Automation",
  "now_you_control": "Now you control the tables and orders at your restaurant automatically, without errors or extra labor to take the orders.",
  "qrcode_self_service": "QR code self-service technology by table; no need for a waiter to take orders.",
  "self_service": "Self-service",
  "customers_place_orders_themselves": "With this self-service, your customers place their orders themselves at the table, and the orders are automatically printed directly in your kitchen in the order they are received.",
  "zero_waste": "Zero waste",
  "indecipherable_handwriting": "Say goodbye to those indecipherable handwriting, errors, and losses in dish preparation. Keep everything running smoothly and efficiently in your restaurant.",
  "closure": "Closure",
  "automatically_separates_calculates": "Quick bill settlement directly at the table or at the cashier. WhatsMenu automatically separates and calculates what each order consumed, allowing you to charge customers individually if they leave before the table is closed, ensuring smooth and error-free transactions.",
  "ordering_system": "The Ordering System",
  "allows_your_customer": "Allows your customer to choose the day and time to receive their order.",
  "allows_customer_they_wish": "Allows the customer to choose the day and time they wish to receive the order.",
  "you_can_sell_24h": "You can sell 24/7, even when your establishment is closed.",
  "prevents_setbacks": "Prevents setbacks, such as the customer being unavailable to receive the order and the delivery person making a wasted trip.",
  "advantages": "Advantages",
  "configure_days_establishment": "Configure the days and times accepted by the establishment.",
  "customer_best_time_for_them": "The customer chooses the best time for them.",
  "helps_improve": "Helps improve the organization of delivery logistics.",
  "speak_with_consultant": "Speak with a consultant now",
  "must_be_between": "The value must be between 0.49 and 0.99",
  "acess": "Acess",
  "delete_addresses": "Delete addresses",
  "addresses_deleted": "Addresses successfully deleted!",
  "control_of": "Control of",
  "error_deleting_addresses": "Error deleting addresses. Check the console for more details.",
  "user": "User",
  "sucess_updated": "successfully updated",
  "something_wrong": "Something went wrong",
  "talk_it_team": "Talk to the IT team",
  "user_profile": "User profile",
  "profile": "Profile",
  "not_registered": "Not Registered",
  "with_area_code": "With area code",
  "owner_cell_phone": "Owner cell phone",
  "owner_email_address": "Owner email address",
  "full_name": "Full name",
  "register_customer": "Register Customer",
  "select_payment_gateway_for_user": "Select the payment gateway for the user before proceeding.",
  "whatsapp": "Phone number",
  "internationalization": "Internationalization",
  "asaas_account_disconnected": "Asaas account disconnected from the profile",
  "unable_disconnect_asaas_account": "Unable to disconnect the Asaas account from the profile.",
  "add_ons": "Add-ons",
  "there_no_services_generate": "There are no services to generate",
  "boleto_generated": "Boleto successfully generated",
  "issue_add_ons": "Issue add-ons",
  "make_sure_boleto_generated": "Make sure a boleto was generated for this invoice",
  "invoice_settlement": "Invoice settlement",
  "reset_security_key": "Reset security key",
  "assign_support": "Assign support",
  "acessing_user_account": "Acessing user account",
  "logging_in": "Logging in...",
  "back_to_list": "Back to list",
  "menu": "Menu",
  "client_contracted_menu_registration": "Client has contracted menu registration",
  "printer": "Printer",
  "client_purchased_printer": "The client purchased a printer",
  "user_data": "User data",
  "salesperson": "Salesperson",
  "responsible_support": "Responsible Support",
  "name": "Name",
  "no_name": "No name",
  "no_email": "No email",
  "invalid_email": "Invalid email",
  "ssn_ein": "SSN/EIN",
  "no_ssn_ein": "No SSN/EIN",
  "invalid": "Invalid",
  "no_whatsapp": "No Phone Number",
  "registration_date": "Registration date",
  "no_date": "No date",
  "login_attempts": "Login attempts",
  "due_date": "Due date",
  "payment_method": "Payment method",
  "card": "Card",
  "password": "Password",
  "your_password": "Your password",
  "passwords": "Passwords",
  "enter_new_password": "Enter the new password",
  "security_key": "Security key",
  "reset": "Reset",
  "access_panel": "Access Panel",
  "not_have_permission_adm": "You do not have permission to access an Administrator account",
  "clear_addresses": "Clear Addresses",
  "clear": "Clear",
  "delete_addresses_customer": "Do you want to delete all addresses or only the ones outside the delivery area?",
  "outside_area": "Outside the delivery area",
  "no": "No",
  "yes": "Yes",
  "user_cancellation": "User Cancellation",
  "cancel_charges_user": "Cancel charges for this user?",
  "version_next": "Version *Next*",
  "test": "test",
  "activate": "Activate",
  "automatic_printing_browser": "Automatic printing through the browser",
  "observations": "Observations",
  "save": "Save",
  "title": "Title",
  "block_profile": "Block Profile",
  "value_whatsapp": "Value on Phone number",
  "enable_shipping_mi": "Enable toggle between neighborhoods and Miles",
  "double_sending_whatsapp": "Double sending on Phone number",
  "enable_pix_online": "Enable Pix Online",
  "enable_online_card": "Enable Online Card",
  "remove_type_street": "Remove type street?",
  "old_pix": "Old Pix",
  "negotiation_fee": "Negotiation fee",
  "days": "days",
  "expires_in": "Expires in",
  "expired_since": "Expired since",
  "disconnect_account": "Disconnect Account Asaas",
  "unlink": "Unlink",
  "account_asaas": "Account Asaas",
  "unlink_asaas_account": "Do you want to unlink the Asaas account from this customer",
  "quantity": "Quantity",
  "issue": "Issue",
  "number_installments": "Number of Installments",
  "invoices": "Invoices",
  "transaction_id": "Transaction ID",
  "value": "Value",
  "total_order": "Total Order",
  "action": "Action",
  "action_remove_user_the": "This action will remove the user from the",
  "notice": "Notice",
  "settlement": "Settlement",
  "warning_financial_password": "WARNING! You need to set up a Financial Password.",
  "warning_v2": "To do this, go to the Settings option in the menu.",
  "passwords_or": "Passwords or",
  "click_here": "Click here",
  "enter_financial_password": "Enter Your Financial Password",
  "confirm": "Confirm",
  "forgot_financial_password": "Forgot your Financial Password",
  "recover_password": "Recover password",
  "check_inbox_spam": "check your 'inbox' or 'spam' folder.",
  "message_subject": "the message with the subject",
  "password_recovery": "Password Recovery",
  "whastmenu": "Whatsmenu",
  "start_date": "Start Date",
  "end_date": "End Date",
  "search": "Search",
  "print": "Print",
  "report": "Report",
  "product": "Product",
  "products": "Products",
  "product_m": "product",
  "qty_sold": "Qty. Sold",
  "total_amount": "Total Amount",
  "cash_summary": "CASH SUMMARY",
  "qty": "Qty.",
  "incomes": "Incomes",
  "table_closing": "Table closing",
  "table": "Table",
  "counter": "Counter",
  "request": "Request",
  "cancelled": "Cancelled",
  "cancelled_up": "CANCELLED",
  "cancelled_o": "Cancelled",
  "outflows": "Outflows",
  "phone_footer": "Phone",
  "phone_abbreviation": "Tel.",
  "n_orders": "No. of Orders",
  "language": "Language",
  "select_language": "Select the Language",
  "client": "Customer",
  "currency": "Currency",
  "brazil": "Brazil (R$)",
  "united_states": "United States ($)",
  "united_kingdom": "United Kingdom (£)",
  "portugal": "Portugal (€)",
  "mexico": "Mexico ($)",
  "paraguay": "Paraguay (₲)",
  "jamaica": "Jamaica (J$)",
  "grenada": "Grenada (EC$)",
  "dubai": "Dubai (د.إ)",
  "ireland": "Ireland (€)",
  "country": "Country",
  "select_currency": "Select Currency",
  "portuguese_brazil": "Portuguese (Brazil)",
  "portuguese_portugal": "Portuguese (Portugal)",
  "spanish_paraguay": "Spanish (Paraguay)",
  "english_us": "English (US)",
  "english_uk": "English (United Kingdom)",
  "english_jamaica": "English (Jamaica)",
  "spanish_mexico": "Spanish (Mexico)",
  "english_grenada": "English (Grenada)",
  "english_ar": "English (Dubai)",
  "english_ireland": "English (Ireland)",
  "german_de": "German (Germany)",
  "average_ticket": "Average Ticket",
  "total_spent": "Total Spent",
  "total_orders": "Total Orders",
  "total_amount_spent": "Total Amount Spent",
  "customer_report": "Customer Report",
  "number_of_orders": "No. of Orders",
  "order_history": "Order History",
  "order_code": "Order Code",
  "change_for": "Change for",
  "change": "Change",
  "payment": "Payment",
  "payment_abbreviation": "Pmt.",
  "all_customers": "All Customers",
  "filter": "Filter",
  "order_volume": "Order Volume",
  "amount_consumed": "Amount Consumed",
  "no_results_found": "No results found",
  "no_customer_found": "No customer found with that name",
  "phone_number": "Phone number",
  "customer_found": "Customers Found",
  "opening_time_must_closing": "The opening time must be later than the closing time!",
  "time_will_not_take": "This time will not take effect on the",
  "following": "Following",
  "day": "Day",
  "changing_existing_time": "consider changing an existing time on the",
  "mentioned": "Mentioned",
  "please_select_day": "Please select a day!",
  "please_set_valid_time": "Please set a valid time!",
  "operating_hours": "Operating hours",
  "the_change_were": "The changes were not made because there are invalid times. Please correct the highlighted fields and try again.",
  "product_availability": "Product Availability",
  "setting_operating_hours": "Setting up operating hours",
  "choose_days_times": "CHOOSE THE DAYS AND TIMES",
  "select_all": "Select All",
  "from": "From",
  "until": "Until",
  "add": "Add",
  "open": "Open",
  "close": "Close",
  "actions": "Actions",
  "invalid_time": "Invalid time",
  "if_work_overnight": "If you also work overnight, meaning after midnight, register the hours like this",
  "pause": "Pause",
  "unpause": "Unpause",
  "delete": "Delete",
  "type": "Type",
  "priority": "Priority",
  "email_server": "Email Server",
  "content": "Content",
  "destination": "Destination",
  "address": "Address",
  "discount": "Discount",
  "surchage": "Surcharge",
  "fixed": "Fixed",
  "percentage": "Percentage",
  "type_of_fee": "Type of fee",
  "type_of_value": "Type of value",
  "fee_amount": "Fee amount",
  "copy": "COPY",
  "successfully_duplicated": "successfully duplicated",
  "not_possible_duplicate": "It was not possible to duplicate the category",
  "unable_duplicate_product": "Unable to duplicate the product.",
  "category": "Category",
  "successfully": "successfully",
  "the_category": "the category",
  "could_not": "Could not",
  "paused": "Paused",
  "unpaused": "Unpaused",
  "the_product": "the product",
  "sizes": "Sizes",
  "size": "Size",
  "edges_doughs": "Edges and Doughs",
  "flavors": "Flavors",
  "menu_information": "Menu Information",
  "cat_standard": "cat. Standard",
  "qty_product": "Qty. Products",
  "qty_add_ons": "Qty. Add-ons",
  "qty_size": "Qty. Sizes",
  "qty_edges_doughs": "Qty. Edges/Doughs",
  "qty_flavors": "Qty. Flavors",
  "you_edited": "You edited",
  "items": "items",
  "cancel_edit": "Do you want to cancel the edit",
  "there_are_no": "There are no",
  "to_update": "to update",
  "disconnect_account_asaas": "Disconnect Account Asaas",
  "package": "Packages",
  "appointments": "Appointments",
  "appointment": "Appointment",
  "share_facebook": "Share on Facebook",
  "copy_clipboard": "Copy to clipboard",
  "copied": "Copied",
  "link_sucess_copied": "Link successfully copied.",
  "unlink_link_copied": "Unable to copy the link, your browser does not support this feature.",
  "message_menu_adjust_prices": "The menu is your product showcase on WhatsMenu. Here, you can create categories, add items, extras, and options, set availability, and adjust prices.",
  "add_category": "Add Category",
  "reorder_menu": "Reorder Menu",
  "search_g": "Search",
  "search_place": "Search...",
  "complements": "Complements",
  "complement": "Complement",
  "pizza_flavors": "Pizza Flavors",
  "duplicate": "Duplicate",
  "edit": "Edit",
  "stock": "Stock",
  "low": "Low",
  "out_stock": "Out of stock",
  "edit_cover": "Edit Cover",
  "add_size": "Add Size",
  "add_item": "Add Item",
  "add_complements": "Add Complement",
  "edit_flavors": "Edit Flavors",
  "cancel_edits": "Cancel Edit",
  "prices": "Prices",
  "price": "Price",
  "photo": "Photo",
  "discard_changes": "Discard changes",
  "enter_valid_value": "Please enter a valid value!",
  "in_stock": "IN STOCK",
  "add_flavors_firt_pizza": "To add flavors, first create a pizza size.",
  "add_flavors": "Add Flavors",
  "updated_now": "Updated now",
  "flavors_will_be": "flavors will be",
  "flavor_will_be": "flavor will be",
  "please_wait": "Please wait...",
  "coin_t": "Coin",
  "please_wait_n": "Please wait",
  "edit_products": "Edit Products",
  "products_will_be": "products will be",
  "product_will_be": "product will be",
  "no_results_your_search": "No results for your search",
  "no_category_registred": "No category registered",
  "add_items_bulk": "Add items in bulk",
  "you_changing_promotional_price": "You are changing the promotional price of the product.",
  "system": "System",
  "cash_detail": "Cash Detail",
  "operator": "Operator",
  "image_preview": "Image Preview",
  "width": "Width",
  "height": "Height",
  "complete": "Complete",
  "review_entered_data": "Please review the entered data.",
  "confirm_financial_password": "Confirm Financial Password",
  "financial_password": "Financial Password",
  "how_to_make": "How to make",
  "updated": "updated",
  "updated_o": "updated",
  "created": "created",
  "unable_delete_category": "Unable to delete the category",
  "standard": "Standard",
  "delete_category": "Delete the category",
  "review_data": "Review the data",
  "details": "Details",
  "availability": "Availability",
  "select_category_model": "Select the category model",
  "acai_ice_creams": "Acai and Ice Creams",
  "burgers": "burgers",
  "meal_boxes": "Meal boxes",
  "meal_boxes_size_options": "Meal boxes with size options",
  "build_meal_box": "Build your own meal box",
  "butcher_shop": "Butcher shop",
  "produce_section": "Produce section",
  "drinks": "Drinks",
  "category_name": "Category name",
  "invalid_category_name": "Invalid category name",
  "characters": "characters",
  "minimum_stock": "Minimum stock",
  "add_availability_hours": "Add availability hours",
  "add_promotion_hours": "Add promotion hours",
  "use_addons_another_item": "Use add-ons from another item",
  "creating_addons": "Creating add-ons",
  "shared_addons": "Shared add-ons",
  "attention": "Attention",
  "attention_up": "ATTENTION",
  "all_changes_addon_affect_other_product": "All changes made to this add-on will affect other products using it.",
  "link": "Link",
  "attention_addon_linked": "Attention this add-on is linked to",
  "attention_addon_linked_v2": "any changes made here will affect the linked products, except for deletions.",
  "other": "other",
  "view_linked_products": "View linked products",
  "invalid_name": "Invalid name",
  "min_greater_max": "Min greater than maximum",
  "max_less_min": "Max less than minimum",
  "mandatory_addon": "Mandatory add-on",
  "option": "Option",
  "please_enter_valid_value": "Please enter a valid value",
  "always_available": "Always available",
  "enable_stock": "Enable stock",
  "created_o": "created",
  "create": "Create",
  "was_deleted_successfully": "was deleted successfully",
  "could_not_delete_flavor": "Could not delete the flavor",
  "you_really_want_delete": "Do you really want to delete",
  "error": "error",
  "the_flavor": "the flavor",
  "flavor": "Flavor",
  "image_up_8": "Image up to 8MB",
  "add_image": "Add Image",
  "recomended_resolution_600": "recommended resolution of 600x450",
  "please_valid_name": "Please enter a valid name.",
  "message_pause_sales": "To pause sales of this item, click the button next to it. If the button is enabled, the item will not appear in your list of dishes.",
  "pause_sales": "Pause Sales",
  "resume_sales": "Resume Sales",
  "created_successfully": "created successfully.",
  "updated_successfully": "updated successfully.",
  "was_not_created": "was not created.",
  "was_not_updated": "was not updated.",
  "deleted_successfully": "deleted successfully.",
  "could_not_delete": "Could not delete.",
  "could_not_pause": "Could not pause",
  "resumed_successfully": "resumed successfully.",
  "paused_successfully": "paused successfully",
  "to_pause_sale_message": "To pause sales of this item, click the button next to it. If the button is enabled, the item will not appear in your list of dishes.",
  "size_name_already_exists": "A size with this name already exists.",
  "the_size": "the size",
  "update": "update",
  "message_delete_remove_another": "To delete, you need to remove the flavors or add another pizza size",
  "message_really_delete_size": "Do you really want to delete the size",
  "message_could_not_delete": "Could not delete the size",
  "edit_size": "Edit Size",
  "cover": "Cover",
  "this_size_accepts": "This size accepts",
  "add_cover": "Add Cover",
  "message_cannot_invalid_times": "Changes cannot be made because there are invalid times. Please correct the highlighted fields and try again",
  "review_not_allowed": "Review your add-ons; empty names are not allowed",
  "could_not_delete_product": "Could not delete the product",
  "delete_the_product": "Delete the product",
  "promotion": "Promotion",
  "activate_promotion": "Activate promotion",
  "button_enable_disable_promotion": "Use the button next to enable or disable the promotion.",
  "original_price": "Original price",
  "promotional_price": "Promotional price",
  "promotion_ends_in": "Ends in",
  "available_for": "Available for",
  "message_products_not_created": "The products were not created because there are invalid times. Please correct the highlighted fields and try again",
  "products_created_successfully": "All products were created successfully.",
  "products_not_created": "Products were not created.",
  "create_products_bulk": "Create Products in Bulk",
  "shortcuts": "Shortcuts",
  "right_arrow": "Right arrow",
  "left_arrow": "Left arrow",
  "next_step": "Next step",
  "back_one_step": "Go back one step",
  "create_products": "Create products",
  "add_product": "Add product",
  "duplicate_product": "Duplicate product",
  "product_name": "Product name",
  "table_price": "Table price",
  "product_description": "Product description",
  "duplicate_r": "Duplicate",
  "no_product_added": "No product added",
  "creating_products": "Creating products...",
  "reordered_successfully": "Reordered successfully",
  "could_not_reorder_items": "Could not reorder the items",
  "message_press_and_hold": "Press and hold for 1 second, then drag the items to the desired position. This sequence will also be reflected in your store.",
  "reordegring_wait": "Reordering, please wait...",
  "you_any_categories_yet": "You haven't registered any categories yet.",
  "please_review_data": "Please review the data.",
  "review": "Review",
  "fee_shipping": "Free Shipping",
  "fee_shipping_up": "FRETE GRÁTIS",
  "fee": "Fee",
  "disc": "Disc.",
  "free": "Free",
  "be_determined": "To be determined",
  "disabled": "Disabled",
  "order_slip": "Order slip",
  "order_slips": "Order slips",
  "ssn": "SSN",
  "duration": "Duration",
  "delivery_date": "Delivery date",
  "paid_up": "PAID",
  "coupon_used": "Coupon used",
  "delivery": "Delivery",
  "coupon": "Coupon",
  "payment_in": "Payment in",
  "total_paid": "Total Paid",
  "checkout": "Checkout",
  "paid_online_up": "PAID ONLINE",
  "delivery_person": "Delivery person",
  "s_n": "Y/N",
  "technology": "Technology",
  "missing": "Missing",
  "waiter": "Waiter",
  "paid": "Paid",
  "delivery_fee": "Delivery Fee",
  "printing_error": "Printing error",
  "could_not_send_printing": "Could not send the copy for printing.",
  "order_confirmation": "Order confirmation",
  "could_not_print_order": "Could not confirm the print of the order",
  "change_date": "Change date",
  "pending_prints": "Pending prints",
  "message_pending_print": "pending print orders. Do you want to print these orders?",
  "there_are": "There are",
  "print_all": "Print all",
  "could_not_play_sound": "Could not play the sound.",
  "printing_up": "PRINTING",
  "cancel_order": "Cancel order",
  "reinstate_order": "Reinstate order",
  "no_orders_print_up": "TTHERE ARE NO ORDERS TO PRINT",
  "order_preview": "Order preview",
  "teste_print_order": "Test print order",
  "report_request": "Report request",
  "received": "Received",
  "preparation": "Preparation",
  "delivering": "Delivering",
  "served": "Served",
  "ready_for_pickup": "Ready for pickup",
  "speak_customer": "Speak with customer",
  "select": "Select",
  "add_address": "Add address",
  "edit_address": "Edit address",
  "filling_establishment_address": "Filling in the establishment's address",
  "zip_code": "ZIP Code",
  "invalid_zip_code": "Invalid ZIP code",
  "number": "Number",
  "neighborhood": "Neighborhood",
  "city": "City",
  "complete_address": "Complete address",
  "confirm_location": "Confirm location",
  "confirm_and_fill_address": "Confirm and fill in the additional details of your address.",
  "enter_your_zip_code_for_address": "Enter your ZIP code to find the address.",
  "requesting_your_location": "Requesting your location...",
  "address_found": "Address found",
  "confirm_address": "Confirm address",
  "enter_your_zip_code": "Enter your ZIP code",
  "i_do_not_know_my_zip_code": "I don't know my ZIP code",
  "save_address": "Save address",
  "choose_saved_address_or_create_new": "Choose a saved address or create a new one to continue the order.",
  "use_my_location": "Use my location",
  "no_saved_address_for_this_client": "No address has been saved for this client yet.",
  "select_delivery_location": "Select the delivery location",
  "inform_city_and_neighborhood_for_delivery": "Tell us the city and neighborhood to calculate the delivery fee.",
  "delivery_to_your_address": "Delivery to your address",
  "searching": "Searching...",
  "complement_address": "Apartment, Block, etc.",
  "enter_registed_email_recover_password": "Enter your registered email to recover your password",
  "your_email": "Registered email",
  "please_enter_valid_email": "Please enter a valid email",
  "email_sent_successfully": "Email sent successfully.",
  "send": "Send",
  "delivery_package": "DELIVERY/PACKAGES",
  "change_order_date": "Change order date",
  "selected_date": "Selected date",
  "current_order_date": "Current order date",
  "distribution": "Distribution",
  "order_coder": "Order code",
  "no_order_selected": "No order selected",
  "go_back": "Go back",
  "pickup": "Pickup",
  "deliver": "Deliver",
  "no_items_this_date": "No items for this date",
  "all": "All",
  "pending": "Pending",
  "marked_received": "Marked as received",
  "local_delivery": "Local delivery",
  "summary_of": "Summary of",
  "your": "your",
  "your_a": "your",
  "filter_use": "Filter in use",
  "choose_date_summary": "Choose a date for the summary",
  "printing": "Printing",
  "selected_orders": "Selected orders",
  "regarding": "Regarding",
  "calendar_view": "Calendar view",
  "loading_orders": "Loading orders...",
  "order_slip_fees": "Order slip fees",
  "fees": "Fees",
  "charge": "Charge",
  "next_confirm": "Next/Confirm",
  "back_cancel": "Back/Cancel",
  "proceed": "Proceed",
  "delivery_report": "Delivery report",
  "qty_of_deliveries": "Deliveries",
  "total_delivery_fees": "Fees",
  "delivery_report_r": "Delivery report",
  "code_order": "Code Order",
  "date": "Date",
  "discard": "Discard",
  "pending_changes": "Pending changes",
  "you_whant_save_them": "There are unsaved changes. Do you want to save them?",
  "new": "New",
  "my_profile": "My profile",
  "delivery_drivers": "Delivery drivers",
  "tables": "Tables",
  "no_active_waiter": "No active waiter",
  "message_register_waitr_enable": "To register a waiter or enable an existing one, go to Settings > Table > in the Waiters tab, or click on",
  "register_waiter": "Register Waiter",
  "coupons": "Coupons",
  "social_media": "Social media",
  "reports": "Reports",
  "financial_report": "Financial report",
  "daily_orders": "Daily orders",
  "monthly_orders": "Monthly orders",
  "cash_register_closing": "Cash register closing",
  "best_sellers": "Best sellers",
  "customer_report_side": "Customer report",
  "general": "General",
  "cash_registers": "Cash registers",
  "domains": "Domains",
  "payment_methods": "Payment methods",
  "administrator": "Administrator",
  "support_bonus": "Support bonus",
  "salesperson_report": "Salesperson report",
  "annual_report": "Annual report",
  "updates": "Updates",
  "exit": "Exit",
  "support_hours": "Monday to Saturday",
  "settings": "Settings",
  "phone": "Phone",
  "press": "Press",
  "order_already_printed": "Order has already been printed",
  "order_not_printed": "Order not printed",
  "wait_order_printed": "Please wait for the order to be printed.",
  "displaying": "Displaying",
  "of": "of",
  "filter_o": "Filter",
  "caption": "Caption",
  "order_list": "Order list",
  "message_download_whatsmenu_desktop": "Download the NEW WhatsMenu Desktop Now",
  "message_less_work": "Less work and more sales",
  "message_virtual_assistant": "Virtual assistant for Phone number",
  "message_loyalty_program": "Loyalty program",
  "message_first_purchase": "First purchase coupon",
  "message_automated_sales_bot": "Automated sales bot",
  "message_status_updates": "Status updates without opening tabs",
  "message_download_app": "Download App",
  "donwload_the_whatsmenu": "Download the WhatsMenu Desktop",
  "message_download_whatsmenu_printers": "Download the new WhatsMenu Printers now",
  "message_automatic_printing_mobile": "Automatic printing on mobile",
  "message_printing_multiple_printers": "Printing on multiple printers",
  "message_copy_printing": "Copy printing",
  "message_download_gplay": "Download Via Google Play",
  "message_downlaod_whatsmenu_printers": "Download WhatsMenu Printers",
  "message_audio_disabled": "Audio disabled. Please interact with the screen to enable it.",
  "message_monthly_invoice_available": "Monthly invoice available for payment! Click here.",
  "message_menu_locked": "Your menu may be locked because your subscription is overdue! Click here.",
  "overview_pos_pizza_addons": "Overview POS and Pizza Add-ons WhatsMenu",
  "how_to_register_customer_pos": "How to register a customer in the POS",
  "guide_placing_order_pos": "Step-by-Step Guide to Placing an Order via POS",
  "how_to_update_customer_information_pos": "How to update customer information via POS",
  "guide_opening_cash_register": "Step-by-Step Guide to Opening the Cash Register",
  "guide_closin_cash_register": "Step-by-Step Guide to Closing the Cash Register",
  "cash_register_closing_reports": "Cash Register Closing Reports",
  "how_place_order_counter_pos": "How to Place a Takeout Order at the Counter via POS",
  "reordering_customers_orders": "Reordering Previous Customer Orders in a Few Clicks",
  "place_order_pizza_pos": "How to Place an Order for a Pizza with 2 or More Toppings, Crusts, and Add-ons via POS",
  "how_create_tables": "How to Create Tables",
  "guide_registering_pizza_crusts": "Step-by-Step Guide to Registering Pizzas with Crusts and Toppings",
  "pos": "POS",
  "internet_connection_lost": "Your internet connection has been lost. Please check your connection.",
  "internnet_connection_reestablished": "Your internet connection has been reestablished.",
  "register_your_customers_quickly_easily": "Register your customers and place orders more quickly and easily.",
  "repeat_your_customer_clicks": "Repeat your customer’s last order in just 2 clicks.",
  "cash_register_simply": "Opening and closing the cash register with simply fantastic reports.",
  "gain_extra_speed": "Gain extra speed in serving tables.",
  "support_more_information": "Your full plan subscription has expired, and we have not detected the payment. Please contact support for more information.",
  "dear_customer": "Dear Customer,",
  "view_menu": "View Menu",
  "have": "have",
  "not_have": "do not have",
  "new_orders": "new orders.",
  "go_to_orders": "Go to orders",
  "general_settings": "General Settings",
  "need_help": "Need Help?",
  "you": "You",
  "copied_clipboard": "Copied to clipboard",
  "copy_n": "Copy",
  "browser_not_have_copy": "Your browser does not have the copy option.",
  "cashback_status": "Cashback Status",
  "cashback_configuration": "Cashback Configuration",
  "loyalty": "Loyalty",
  "percentage_of": "Percentage",
  "percentage_up": "PERCENTAGE",
  "validity": "Validity",
  "days_n": "Days",
  "in_days": "In days",
  "how_to_configure_cashback": "How to Configure Cashback on WhatsMenu",
  "activate_cashback": "Activate Cashback",
  "promotion_link": "Promotion Link",
  "profile_information": "Profile Information",
  "store_name": "Store Name",
  "enter_store_name": "Enter the Store Name",
  "enter_slug": "Enter your slug",
  "contact_phone_number": "Contact Phone Number",
  "enter_contact_phone": "Enter the contact phone number",
  "message_phone_number_will": "This phone number will only be available to customers with ongoing orders.",
  "enter_store_description": "Enter your store description",
  "minimum_delivery_order": "Minimum Delivery Order",
  "minimum_order_excluding_delivery": "Minimum order value, excluding delivery fee.",
  "minimum_order_pickup": "Minimum Order for Pickup",
  "minimum_order_pickup_delivery": "Minimum order value for pickup, excluding delivery fee.",
  "preview_your_store": "Preview of your store",
  "preview": "Preview",
  "open_n": "Open",
  "calculate": "Calculate",
  "store_color": "Store Color",
  "wait_time": "Wait Time",
  "establishment": "Establishment",
  "store_layout": "Store Layout",
  "shipping": "Shipping",
  "congratulations": "Congratulations",
  "message_few_steps_organized": "In just a few steps, you'll have a fast and organized service with your",
  "digital_menu": "Digital Menu.",
  "basic_details_establishment": "Now fill in the basic details of your establishment.",
  "filling_profile": "Filling out profile",
  "restaurant_address": "Restaurant Address",
  "message_plan_not_include_delivery": "Your current plan does not include the Delivery or Orders/Scheduling functionality. Please contact support for more details.",
  "closing_scheduled_time": "Closing outside the scheduled time",
  "reopening_date": "Reopening Date",
  "time_zone": "Time Zone",
  "select_time_zone": "Select your time zone",
  "now": "Now",
  "add_business_hours": "Add Business Hours",
  "store": "Store",
  "closed": "Closed",
  "open_a": "open",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "sunday": "Sunday",
  "delivery_fees": "Delivery Fees",
  "shipping_neighborhood": "Shipping by neighborhood",
  "shipping_by_mi": "Shipping by MI",
  "mile": "Mile",
  "delivery_type_change_to": "Delivery type changed to",
  "loading": "Loading...",
  "delivery_type": "Delivery Type",
  "by_mile": "By Mile",
  "reset_fees": "Reset Fees",
  "message_fee_deleted": "If you change the fee type, all current fees will be deleted",
  "message_really_change_fee": "Do you really want to change the fee type",
  "by_neighborhood": "By Neighborhood",
  "neighborhood_name": "Neighborhood Name",
  "neighborhood_cannot_duplicated": "The neighborhood cannot be duplicated",
  "to_be_confirmed": "To be confirmed",
  "neighborhood_added": "Neighborhood added",
  "city_and_neighborhood_added": "City and neighborhood added",
  "neighborhood_deleted": "Neighborhood deleted",
  "city_deleted": "City deleted",
  "time_minutes": "Time in Minutes",
  "changes_made_successfully": "Changes made successfully",
  "unexpected_try_again": "Something unexpected happened. Please try again.",
  "success": "Success",
  "stripe_international_payments": "International Payments",
  "stripe_international_payments_description": "Accept global cards, Apple Pay, and Google Pay with automatic order approval.",
  "asaas_logo_alt": "Asaas logo",
  "online_payment_automatic": "Online Payment - Automatic",
  "message_avoid_fraud_errors": "Avoid fraud, errors, and delays in service by not having to verify receipts in the banking app.",
  "asaas_terms_use": "Asaas Bank Terms of Use",
  "complete_activation_account": "Attention: complete the activation of your account",
  "acess_email": "Access the email",
  "message_open_asaas_email": "Open the Asaas email and click the link to create your banking password.",
  "message_sent_sms_token": "We have sent the SMS with the token to",
  "account_creation_details": "Account Creation Details",
  "branch": "Branch",
  "account_label": "Account",
  "acess_asaas_account": "Access your Asaas account",
  "termis_of_use": "Terms of Use",
  "webhooks": "Webhooks",
  "webhook": "Webhook",
  "unable_fetch_webhook_status": "Unable to fetch webhook statuses",
  "webhook_updated_successfully": "Webhook updated successfully",
  "unable_update_webhook_status": "Unable to update webhook statuses",
  "confirm_change": "Confirm change",
  "webhook_confirm_message": "Do you want to {{action}} the webhook <b>{{name}}</b>?",
  "online_payment": "Online Payment",
  "payment_on_delivery_card": "Payment on Delivery - Card Reader",
  "payment_on_delivery": "Payment on Delivery",
  "automate_your_payments": "Automate the receipt of your payments",
  "activate_this": "Activate This",
  "notes": "Notes",
  "up_two_business_days": "Up to 2 business days",
  "acess_detailed_statements_asaas": "Note: Access your Asaas Bank app for detailed statements.",
  "enable_surcharge_discount": "Enable Surcharge/Discount",
  "disabled_o": "Disabled",
  "activated": "Activated",
  "card_network": "Card Network",
  "add_card_network": "Add Card Network",
  "key_type": "Key Type",
  "key": "Key",
  "invalid_pix": "Invalid Pix",
  "money": "Money",
  "pix": "Pix",
  "zelle": "Zelle",
  "twint": "Twint",
  "picpay": "PicPay",
  "credit_card": "Credit Card",
  "credit": "Credit",
  "debit": "Debit",
  "register_password": "Register Password",
  "meal_voucher": "Meal Voucher",
  "food_voucher": "Food Voucher",
  "month": "Month",
  "year": "Year",
  "january": "January",
  "february": "February",
  "march": "March",
  "april": "April",
  "may": "May",
  "june": "June",
  "july": "July",
  "august": "August",
  "september": "September",
  "october": "October",
  "november": "November",
  "december": "December",
  "search_for": "Search for",
  "summary": "Summary",
  "detailed_summary": "Detailed Summary",
  "number_orders": "Number of Orders",
  "no_fees": "No Fees",
  "no_deliverys": "No Deliveries",
  "deliverys": "Deliveries",
  "number_deliveries": "Number of Deliveries",
  "products_total": "All products added",
  "tax_delivery_total": "Total delivery taxes for the period",
  "total_sales_and_coupons": "Total sales for the period - Total coupons (Disregarding payment fees/discounts)",
  "total_canceled": "Total Canceled",
  "number_canceled_orders": "Number of Canceled Orders",
  "total_fees": "Total Fees",
  "no_fees_period": "No fees for this period",
  "fixed_amount": "FIXED AMOUNT",
  "fixed_amount_n": "Fiex Amount",
  "payment_methods_n": "Payment Methods",
  "waitstaff": "Waitstaff",
  "creation_date": "Creation Date",
  "daily_report": "Daily Report",
  "monthly_report": "Monthly Report",
  "delivery_registration": "Delivery Personnel Registration",
  "error_deleting_delivery_person": "Error deleting delivery person",
  "error_pausing_activating": "Error pausing/activating delivery person",
  "error_editing_delivery_person": "Error editing delivery person",
  "delivery_person_name": "Delivery Person's Name",
  "enter_delivery_person": "Enter the delivery person's name",
  "enter_whatsapp_number": "Enter Phone number",
  "registered_delivery": "Registered Delivery Personnel",
  "fill_all_fields": "Please fill in all the fields.",
  "coupon_management": "Coupon Management",
  "coupon_code": "Coupon Code",
  "coupon_already_exists": "This coupon already exists",
  "coupon_invalid_chars": "Special characters are not allowed",
  "coupon_allowed_chars_hint": "Only letters, numbers, hyphen (-) and underscore (_)",
  "coupon_code_valid": "Code available",
  "offer_type": "Offer Type",
  "coupon_type": "Coupon Type",
  "first_purchase": "First Purchase",
  "discount_amount": "Discount Amount",
  "minimum_amount": "Minimum Amount",
  "code": "Code",
  "unable_create_the_coupon": "Unable to create the coupon",
  "coupon_not_created": "Coupon not created.",
  "status_coupon": "Coupon Status",
  "actives": "actives",
  "for_orders": "for orders",
  "inactive": "inactive",
  "successfully_deleted": "successfully deleted",
  "delete_coupon": "Delete Coupon",
  "business_offer_deliveries": "Does your business offer deliveries",
  "customer_pick_up_order_onsite": "The customer can pick up the order on-site",
  "cash_register": "Cash Register",
  "active_cash_management": "Activate cash register management",
  "message_currently_open_cash": "You currently have open cash registers. Please close them by",
  "before_register_management": "before changing the cash register management",
  "customers": "Customers",
  "display_date_birth": "Display Date of Birth",
  "require_date_birth": "Require Date of Birth",
  "default_texts": "Default Texts",
  "changing_default_text_observations": "Changing default text for observations",
  "product_note": "Product Note",
  "example_no_mayonnaise": "E.g., No mayonnaise, no salad, etc.",
  "pizza_note": "Pizza Note",
  "leave_any_note_product_here": "Leave any note about the product here.",
  "message_client": "Hello [NOME], how are you?",
  "status_received": "Status Received",
  "you_order_production": "[NOME] Your order is already in production!",
  "status_delivering": "Status Delivering",
  "yay_order_already_way": "Yay [NOME], your order is already on its way!",
  "status_pickup": "Status Pickup",
  "finished": "Finished",
  "order_ready_pickup": "Yay, [NOME], your order is ready for pickup!",
  "order_status_pos": "Order Status in POS",
  "order_successfully_placed": "[NOME], your order was successfully placed. Track your order status below!",
  "greeting_message": "Greeting Message",
  "message_hello": "Hello, [NOME]!",
  "welcome_to": "Welcome to",
  "check_menu_order": "Check out our menu to place your order",
  "exclusive_offers": "Exclusive offers for orders through the link",
  "team": "Team",
  "use_a_printer": "Use a printer",
  "group_order_printing": "Group order items for printing",
  "print_test": "Print Test",
  "test_print": "Test Print",
  "printer_driver": "Printer Driver",
  "others": "Others",
  "printing_app": "Printing App",
  "print_width": "Print Width",
  "letters": "Letters",
  "small": "Small",
  "large": "Large",
  "copies": "Copies",
  "necessary_whatsmenu_android_installed": "It is necessary to have the Whatsmenu Printer 2.0 app installed (Android only).",
  "pizza_options": "Pizza Options",
  "assign_price_most_expensive": "Assign the price of the most expensive",
  "different_crusts_each_flavor": "Allow different crusts for each flavor",
  "allow_each_flavor": "Allow toppings for each flavor",
  "stock_options": "Stock Options",
  "display_out_of_stock_product_addons": "Display 'out of stock' status for paused products and add-ons?",
  "hide_ssn_receipt": "Hide SSN option on the receipt",
  "description_top_product_page": "Display product photo and description at the top of the product page",
  "activate_catalog_mode_delivery": "Activate Catalog Mode in Delivery",
  "activate_catalog_the_table": "Activate Catalog Mode at the Table",
  "automations": "Automations",
  "ignore_products_and_categories_availability": "Ignore the products and categories availability schedule",
  "send_status_page_pos_customer": "Do you want to send the status page on the POS to the customer",
  "only_indentification": "Only the identification",
  "label": "Label",
  "saving": "Saving...",
  "are_no_pending_changes": "There are no pending changes",
  "no_changes": "No changes",
  "saved": "Saved",
  "saved_successfully": "Saved successfully.",
  "order_date": "Order Date",
  "tomorrow": "Tomorrow",
  "today": "Today",
  "deliver_pickup": "Delivering/Pickup",
  "delivery_e": "Delivery",
  "closed_o": "Closed",
  "receive_orders_from": "To receive orders from",
  "enable_options_the_settings_for": "enable the options in the settings for",
  "printed": "Printed",
  "are_no_orders_moment": "There are no orders at the moment",
  "hours": "Hours",
  "review_delivery_hours": "Please review the delivery hours.",
  "changes_saved": "Changes saved successfully.",
  "not_saved": "Not Saved",
  "unable_save_check_connection": "Unable to save changes, please check your connection.",
  "no_changes_to_save": "There are no changes to save.",
  "delivery_type_activated": "At least one delivery type must be activated",
  "pickups": "Pickups",
  "deliveries_pickups": "Deliveries/Pickups",
  "delivery_types_must_one_activated": "Delivery types must have at least one activated",
  "activate_orders": "Activate Orders",
  "delivery_scheduling": "Delivery Scheduling",
  "order_settings": "Order Settings",
  "pickup_onsite": "Pickup On-Site",
  "allow_onesite_pickups": "Allow On-Site Pickups",
  "allow_delivery_services": "Allow Delivery Services",
  "make_available": "Make Available",
  "starting_from": "starting from",
  "allow": "Allow",
  "for_day": "for the day",
  "within": "within",
  "group": "Group",
  "every": "every",
  "preparationTime": "Preparation time",
  "minutes": "Minutes",
  "max_of": "Max. of",
  "per_day_from": "per day from 1 to 1000",
  "per_hour": "per hour",
  "display_menu_as": "Display on the menu as",
  "minimum_for_delivery": "Minimum for delivery",
  "minimum_for_pickup": "Minimum for pickup",
  "register_order_cash_register": "Register Orders at the Cash Register",
  "on_day_ordered": "On the day it was ordered",
  "on_delivery_day": "On the delivery day",
  "availability_of": "Availability of",
  "dates_not_be_available": "Dates you will not be available",
  "select_special_dates": "Select the special dates you will not be available",
  "select_a_date": "Select a date",
  "defined_dates": "Defined Dates",
  "remove": "Remove",
  "values": "Values",
  "minimum_order_for_pickup": "Minimum Order for Pickup",
  "table_name_already_exists": "A table with this name already exists",
  "create_table": "Create Table",
  "enter_valid_name": "Please enter a valid name",
  "new_table": "New Table",
  "creating_table": "Creating table",
  "using_table_system": "Using table system",
  "time_zone_successfully_changed": "Time zone successfully changed",
  "table_name": "Table Name",
  "cancel": "Cancel",
  "available": "Available",
  "occupied": "Occupied",
  "paused_a": "Paused",
  "selected": "Selected",
  "you_haven_registered_tables": "You haven't registered any tables yet",
  "how_close_entire_table": "How to close the entire table",
  "how_close_individual": "How to close individual tabs",
  "table_settings": "Table Settings",
  "fee_name_already_exists": "A fee with this name already exists.",
  "fee_name_cannot_empty": "Fee name cannot be empty.",
  "enter_value_greater_than": "Enter a value greater than",
  "add_fee": "Add Fee",
  "created_successfully_a": "created successfully",
  "activate_fee": "Activate Fee",
  "automatic_charge": "Automatic Charge",
  "changed_successfully": "changed successfully",
  "delete_fee": "Delete Fee",
  "deleted_successfuly": "deleted successfully",
  "register_waitstaff": "Register Waitstaff",
  "update_waitstaff": "Update Waitstaff",
  "create_waitstaff": "Create Waitstaff",
  "edit_waitstaff": "Edit Waitstaff",
  "delete_waitstaff": "Delete Waitstaff",
  "deleted_successfully_o": "deleted successfully",
  "restrict_menu": "Restrict Menu",
  "unable_retrieve_menu_information": "Unable to retrieve menu information at the moment, please try again",
  "creating_fees": "Creating fees",
  "fee_name": "Fee Name",
  "fee_already_exists": "This fee already exists",
  "type_charge": "Type of Charge",
  "enter_number_greater_than": "Enter a number greater than",
  "charge_automatically": "Charge Automatically",
  "deactive": "Deactivate",
  "registering_waitstaff": "Registering Waitstaff",
  "placing_order_waiter": "Placing an order as a waiter",
  "placing_pizza_order_waiter": "Placing a pizza order as a waiter",
  "waitstaff_name": "Waitstaff Name",
  "permission": "Permission",
  "manager": "Manager",
  "allow_orders": "Allow Orders",
  "register": "Register",
  "categories": "Categories",
  "select_categories_waiter_permitted": "Select which categories the waiter will be permitted to order from",
  "call_waitstaff": "Call Waitstaff",
  "keep_waitstaff_logged": "Keep waitstaff logged in",
  "change_password": "Change password",
  "change_table": "Change Table",
  "enter_valid_name_different_current": "Please enter a valid name or a name different from the current one",
  "delete_table": "Delete Table",
  "activated_a": "activated",
  "pause_table": "Pause Table",
  "not_possible_pause_table_open": "It is not possible to pause tables with open tabs",
  "table_options_up": "TABLE OPTIONS",
  "points": "Points",
  "settings_up": "SETTINGS",
  "background": "Background",
  "resources": "Resources",
  "register_cashier": "Register Cashier",
  "registering_operator": "Registering Operator",
  "placing_order_operator": "Placing an order as an operator",
  "operator_name": "Operator Name",
  "operators": "Operators",
  "box_settings": "Cashier Settings",
  "delete_operator": "Delete Operator",
  "edit_operator": "Edit Operator",
  "create_operator": "Create Operator",
  "update_operator": "Update Operator",
  "register_operator": "Register Operator",
  "there_failure_transaction": "There was a failure in the transaction",
  "change_card": "Change Card",
  "unable_change_payment_card": "Unable to change the payment card.",
  "redirecting_payment_page": "Redirecting to the Payment Page.",
  "difficulty_generating_payment_screen": "We’re having difficulty generating the payment screen. Please try again.",
  "payment_gateway": "Payment Gateway",
  "no_payment_gateway_found": "No payment gateway was found",
  "subscription": "Subscription",
  "adding_your_subscription": "We are adding your subscription.",
  "failure_adding_your_subscription": "There was a failure in adding your subscription",
  "subscription_created_successfully": "Your subscription has been created successfully",
  "failure_processing_try_again": "There was a failure in processing. Please try again",
  "ongoing_monthly_invoice": "There is an ongoing monthly invoice.",
  "subscription_canceled": "Your subscription is canceled",
  "required": "Required",
  "required_complement_all_items_paused": "Cannot save: in \"{{name}}\", all items are paused but this add-on is required. Unpause at least one item or uncheck \"Required add-on\".",
  "additional": "Additional",
  "monthly": "Monthly",
  "annual": "Annual",
  "semiannual": "Semi-Annual",
  "monthly_payment": "Monthly payment by card",
  "add_registration_service": "Add registration service",
  "with_printer": "With printer",
  "select_option": "Select an option",
  "start_registration": "Start Registration",
  "proceeding_whatsmenu_contact": "By proceeding, I agree that WhatsMenu may contact me by phone, email, or WhatsApp (including automated messages for commercial purposes).",
  "message_failure_payment_card": "There was a failure in processing the payment. Please check the details and ensure there is available credit on your card",
  "owner_name": "Owner's Name",
  "payment_completed_successfully": "Payment completed successfully. We will reload the page.",
  "outstanding_invoices": "Pending Invoices",
  "in_progress": "In Progress",
  "pay": "Pay",
  "view_items": "View Items",
  "cart": "Cart",
  "check_items": "Check the items",
  "there_no_items_moment": "There are no items at the moment",
  "unique": "Unique",
  "hello": "Hello",
  "after_payment_confirmation": "after payment confirmation, you will be redirected and the page will be reloaded.",
  "proceed_payment": "Proceed to Payment",
  "pending_pay": "Pending Payment",
  "refunded": "Refunded",
  "under_review": "Under Review",
  "awaiting_confirmation": "Awaiting Confirmation",
  "your_monthly_every_day": "Your monthly fee is due every day.",
  "each_month": "each month",
  "services": "Services",
  "plan": "Plan",
  "generate_invoice": "Generate Invoice",
  "view_invoice": "View Invoice",
  "no_outstandigin_invoices_moment": "There are no outstanding invoices at the moment.",
  "paid_invoice_history": "Paid Invoice History",
  "detail_table": "Detail Table",
  "order_results": "Order Results",
  "displaying_orders_date_from": "Displaying orders by date from",
  "domain_registered_dns_registration": "Domain registered successfully! Please contact support to request DNS registration.",
  "domain_registered": "Domain registered successfully!",
  "domain_already_registered": "This domain is already registered",
  "enter_valid_domain": "Please enter a valid domain",
  "invalid_domain": "Invalid Domain",
  "domain_not_valid": "This domain is not valid. Please enter a valid domain",
  "domain_successfully_deleted": "Domain successfully deleted",
  "delete_domain": "Delete Domain",
  "default_domain_successfully_changed": "Default domain successfully changed",
  "dns_entry": "DNS Entry",
  "dns_entry_successfully": "DNS entry successfully deleted",
  "domain_settings": "Domain Settings",
  "after_registering_domain": "After registering the domain, you will need to point it to these servers",
  "domain": "Domain",
  "domain_information": "Domain Information",
  "registered_domains": "Registered Domains",
  "default_domain_cannot_deleted": "The default domain cannot be deleted. Please contact support",
  "domain_com": "domain.com",
  "default_domain": "Default Domain",
  "monthly_orders_report": "Monthly Orders Report",
  "daily_orders_report": "Daily Orders Report",
  "box_closures": "Box Closures",
  "box_report": "Box Report",
  "customer_report_v2": "Customer Report",
  "best_selling_report": "Best-Selling Report",
  "best_sellers_v2": "Best Sellers",
  "click_here_view_details": "Click here to view the details",
  "summary_last_months": "Summary of the last 12 months",
  "summary_last_days": "Summary of the last 30 days",
  "financial": "Financial",
  "ph": "Phone",
  "dailys": "Daily",
  "monthlys": "Monthly",
  "opening": "Opening",
  "export_spreadsheet": "Export to spreadsheet",
  "creation": "Creation",
  "period": "Period",
  "total_period": "Total for the period",
  "delivery_m": "delivery",
  "ready": "Ready",
  "spreadsheet": "Spreadsheet",
  "successfully_generated": "successfully generated",
  "no_orders_found": "No orders found",
  "empty": "Empty",
  "outputs": "Outputs",
  "daily": "Daily",
  "motoboys_daily": "Daily",
  "motoboys_dailys": "Dailys",
  "deliveries_statement": "Deliveries Statement",
  "delivery_driver_signature": "Delivery driver signature",
  "operators_boxes": "Operators Boxes",
  "box_listing": "Box Listing",
  "opening_date": "Opening Date",
  "closing_date": "Closing Date",
  "box_closure": "Box Closure",
  "paid_a": "Paid",
  "food": "Food Voucher",
  "snack": "Meal Voucher",
  "order_printed_please_wait_finish": "An order is being printed, please wait for it to finish",
  "password_settings": "Password Settings",
  "access": "access",
  "security": "security",
  "incorrect_current_password": "Incorrect current password",
  "register_financial_password": "Register a financial password",
  "change_financial_password": "Change Financial Password",
  "register_password_financial": "Register Financial Password",
  "current_password": "Current Password",
  "new_password": "New Password",
  "confirm_password": "Confirm Password",
  "change_access_password": "Change Access Password",
  "recover_financial_password": "Recover Financial Password",
  "confirm_new_password": "Confirm New Password",
  "authentication_failure": "Authentication Failure",
  "password_recovery_token": "Password recovery token expired or invalid",
  "use_printer": "Use Printer",
  "enable_stock_control": "Enable Stock Control",
  "stock_control": "Stock Control",
  "layout_options": "Layout Options",
  "security_password_registered": "Security password registered successfully",
  "my_name_is": "My name is",
  "no_time_up": "NO TIME",
  "with": "with",
  "consult": "Consult",
  "link_for_order_status": "Link for order status",
  "chosen_date_earlier_current_date": "The chosen date is earlier than the current date. Please select a later date.",
  "check_the_cvv": "Check the CVV",
  "check_card_details": "Check the card details",
  "check_billing_address": "Check the billing address",
  "check_card_expiration_date": "Check the card's expiration date",
  "check_card_number": "Check the card number",
  "check_security_code": "Check the security code",
  "check_zip_code": "Check the ZIP code",
  "unable_register_your_order_try_again": "Unable to register your order. Please try again.",
  "system_identified_you_are_outside": "The system has identified that you are outside our coverage area. Please try to complete your order again.",
  "swiss_french": "Swiss French (Fr.)",
  "swiss_french_chf": "Swiss French ",
  "jamaican_dollar": "Jamaican Dollar",
  "mexican_peso": "Mexican Peso",
  "eastern_caribbean_dollar": "Eastern Caribbean Dollar",
  "integrations": "Integrations",
  "stripe": "Stripe",
  "stripe_invalid_api_key": "Enter a valid API key.",
  "stripe_test_key_not_allowed": "Test keys are not allowed. Please use a production key (sk_live_).",
  "stripe_integration_saved_successfully": "Stripe integration saved successfully.",
  "stripe_integration_save_error": "Unable to save the integration. Please try again.",
  "stripe_logo_alt": "Stripe logo",
  "stripe_description_1": "Stripe is a global financial infrastructure platform that allows restaurants of all sizes to accept online payments worldwide.",
  "stripe_description_2": "Create an account and start accepting multi-currency payments, with no contracts or banking data.",
  "stripe_international_currencies": "International currencies",
  "stripe_currency_flag_alt": "{{code}} flag",
  "stripe_connect_account": "Connect my Stripe account",
  "stripe_api_key_label": "Stripe API Key",
  "stripe_api_key_placeholder": "sk_live_...",
  "stripe_currency_cad": "Canadian dollar",
  "stripe_currency_eur": "Euro",
  "stripe_currency_mxn": "Mexican peso",
  "stripe_currency_aud": "Australian dollar",
  "stripe_currency_gbp": "Pound sterling",
  "stripe_currency_nzd": "New Zealand dollar",
  "stripe_currency_cnh": "Chinese renminbi",
  "stripe_currency_jpy": "Japanese yen",
  "stripe_currency_usd": "US dollar",
  "stripe_currency_chf": "Swiss franc",
  "stripe_currency_sek": "Swedish krona",
  "stripe_currency_hkd": "Hong Kong dollar",
  "stripe_currency_try": "Turkish lira",
  "stripe_currency_krw": "South Korean won",
  "stripe_digital_wallets_title": "Google Pay & Apple Pay",
  "stripe_digital_wallets_description": "Stripe also supports payments via Google Pay and Apple Pay, offering your customers a fast and secure checkout experience.",
  "stripe_fees_title": "Stripe Fee Transfer",
  "stripe_fees_description": "Configure additional fees that will be automatically charged when the customer pays via Stripe.",
  "stripe_fees_enable": "Charge Stripe fees",
  "stripe_fees_enable_description": "When enabled, the configured fees will be added to the order total at Stripe checkout.",
  "stripe_fees_fixed_label": "Fixed fee",
  "stripe_fees_fixed_placeholder": "0.00",
  "stripe_fees_percentage_label": "Percentage fee (%)",
  "stripe_fees_percentage_placeholder": "0.00",
  "stripe_fee": "Stripe Fee",
  "online_payment_s": "Online Payments",
  "online_payment_description": "Avoid fraud, errors, and delays by verifying receipts in the bank app; the order arrives on the panel, and the payment is securely processed directly to your account.",
  "credit_online": "Online Credit",
  "fiscal_note_issuer": "NFe and NFCe Issuer",
  "fiscal_note_issuer_description": "Stop wasting time manually issuing invoices. Set up automations and configure limits according to your CNPJ classification.",
  "grove_nfe_description": "Automatic Invoice Issuance and Management",
  "automation_of_nfe": "Invoice automation",
  "set_the_environment": "Set the Environment",
  "origin": "Origin",
  "not_received": "Not received",
  "marketing_and_sales": "Marketing and Sales",
  "we_integrate_your_store": "We integrate your store with the biggest marketing and sales tools on the market, attract more customers and sell much more with less work.",
  "own_website": "Own Website",
  "disponibility": "Disponibility",
  "please_enter_valid_name": "Please enter a valid name!",
  "image_up": "Image up to 8mb (recommended resolution of 600x450)",
  "share": "Share",
  "fill_all_required": "Fill in all required fields",
  "billing": "Billing",
  "result_orders": "Result Orders",
  "viewing_orders_by_date": "Viewing orders by date",
  "enable_original_image_size": "Enable original image size",
  "cashback": "Cashback",
  "no_register": "No registration",
  "load_complements_wait": "Loading complements, please wait",
  "deactivated_delivery": "Disable Delivery",
  "status_order": "order status",
  "completed": "completed",
  "slug": "Slug",
  "clone_categories": "Clone Categories",
  "clone": "Clone",
  "no_change_needed": "No change needed",
  "serivce_fee": "Service Fee",
  "customer_delivery_address": "Customer Delivery Address",
  "not_informed": "Not informed",
  "route_up": "ROUTE",
  "payments_in": "Payments in",
  "the_order_is_now_ready": "the order is now ready for collection! Here is the customer's contact information",
  "if_you_need": "if you need",
  "reference": "Reference",
  "pickup_the_location": "Local Pickup",
  "table_request": "Table request",
  "possible": "Possible",
  "the_date_of_your_delivery": "The date of your delivery is",
  "sounds_notification": "Order notification sound",
  "play_sound_delivery": "Enable delivery sound",
  "play_sound_eat_on_site": "Enable eat on site order sound",
  "play_sound_table": "Enable table order sound",
  "play_sound_package": "Enable scheduling sound",
  "payment_debit_card": "payment by debit card",
  "payment_credit_card": "payment by credit card",
  "zip_invalid": "Invalid ZIP code",
  "enter your cpf": "Enter your CPF",
  "n": "No.",
  "cash_outflows": "outflows",
  "cod": "code",
  "out for delivery": "out for delivery",
  "add_another_card": "add another card",
  "mbway": "MBWay",
  "spin": "Spin",
  "hide_unity": "Disable quantity",
  "Delivery_options": "Delivery Options",
  "Profile_options": "Profile Options",
  "catalog_mode": "Catalog Mode",
  "showLocale": true,
  "additionals": "Additionals",
  "order_cod": "Order Code",
  "cancel_edit_message": "Do you want to cancel the edit?",
  "options": "Options",
  "closed_a": "closed",
  "opening_balance": "Opening balance",
  "tax_settings": "NFe Settings",
  "edit_company": "Edit Company",
  "add_company": "Add Company",
  "configure_emission": "Configure Emission",
  "company": "Company",
  "natural_person": "Natural Person",
  "company_name": "Corporate Name",
  "certificate": "e-CNPJ A1",
  "attach_certificate": "Attach A1 Model Certificate",
  "identification": "Identification",
  "responsable": "Responsible",
  "accounting": "Accounting",
  "tokens": "tokens",
  "tax_documents": "Tax Documents",
  "attach_company_logo": "Attach company logo",
  "trade_name": "Trade Name",
  "state_registration": "State Registration",
  "municipal_registration": "Municipal Registration",
  "tax_regime": "Tax Regime",
  "select_an_option": "Select an option",
  "simple_national": "Simple National",
  "Excess_gross_revenue_sublimit": "Excess gross revenue sublimit",
  "normal_regime": "Normal Regime",
  "email": "Email",
  "ein": "EIN",
  "municipality": "Municipality",
  "fu": "State",
  "responsible_name": "Responsible Name",
  "responsible_ssn": "Responsible CPF",
  "approval_token": "Approval Token",
  "production_token": "Production Token",
  "approval": "Approval",
  "series": "Series",
  "next_number": "Next number",
  "id_approval_token": "Approval Token ID",
  "security_code_approval": "Approval CSC",
  "production": "Production",
  "id_production_token": "Token ID",
  "security_code_production": "CSC",
  "advanced_settings": "Advanced Settings",
  "electronic_consumer_fiscal_note": "NFCe",
  "enable_offline_contingency": "Enable offline contingency",
  "all_documents": "All Documents",
  "send_email_to_recipient": "Send email to recipient",
  "discriminate_taxes": "Discriminate Taxes",
  "electronic_fiscal_note": "NFe",
  "show": "Show",
  "auxiliary_document_for_the_electronic_fiscal_notes": "DANFSe",
  "show_badge_focus_efn_on_adefn": "Show Focus NFe badge on DANFSe",
  "emission_ecfn": "NFCe Emission",
  "whenever_necessary_you_can_manually_issue_in_addition_to_the_defined_standard": "Whenever necessary, you can manually issue in addition to the defined standard",
  "set_defaults_for_automatic_issuance_of_your_fiscal_notes": "Set defaults for automatic issuance of your fiscal notes",
  "daily_average": "Daily Average",
  "credit_machine": "Credit Machine",
  "debit_machine": "Debit Machine",
  "debit_online": "Online Debit",
  "dont_miss_deadlines": "Don't miss deadlines",
  "we_will_send_the_fiscal_closing": "We will send the monthly fiscal closing (XML) to your accountant",
  "accountant_email": "Accountant's Email",
  "additional_service": "Additional Service",
  "gratis": "Free",
  "for_shopkeeper": "for shopkeeper",
  "WM": "WhatsMenu",
  "plan_change": "Plan Change",
  "current_plan": "Current Plan",
  "plan_expiration": "Plan Expiration",
  "change_plan": "Change Plan",
  "certificate_password": "Your A1 Model Certificate Password",
  "unable_to_read": "Unable to read your location, please check if location services are not blocked.",
  "address_covarage_area": "Your address is outside our coverage area!",
  "register_open_24": "A register has been open for more than 24 hours and will be closed.",
  "table_desactived": "Sorry, this table is currently disabled.",
  "moment_table_not_avaible": "At the moment, this table is not available for new orders.",
  "table_not_avaible_new_orders": "At the moment, this table is not available for new orders.",
  "order_already_been_completed": "The previous order has already been completed. Are you still at the restaurant or would you like to place a new order for delivery?",
  "at_the_table": "I'm at the table",
  "deliver_order": "Deliver order",
  "not_belong_this_table": "This order does not belong to this table.",
  "store_closed": "STORE CLOSED!",
  "not_minimum_value": "Your order has not reached the minimum amount of",
  "failed_validate_coupon": "Failed to validate the coupon, please check your connection!",
  "amount_not_include_delivery_fee": "This total amount does not include the delivery fee.",
  "coupon_used_starting_from": "This coupon can only be used for purchases starting from",
  "closed_delivery": "CLOSED FOR DELIVERY",
  "unable_create_customer": "Unable to create the customer. Please try again.",
  "selected_date_earlier_choose_later_date": "The selected date is earlier than the current date, please choose a later date.",
  "try_again_moment": "Something unexpected happened, please try again in a moment.",
  "error_generate_qrcode": "Unable to generate QR Code. Please try again.",
  "payment_not_detected": "Payment not detected. Please check your banking app.",
  "reloaded_page_message": "The page needs to be reloaded!",
  "name_and_last_name_and_phone_required": "Name, last name and phone number are required",
  "enter_your_details": "Enter your details",
  "enter_your_name": "Enter your name",
  "enter_your_whatsapp": "Enter your WhatsApp",
  "enter_your_date_of_birth": "Enter your date of birth",
  "review_change_amount": "Review the Change Amount!",
  "no_internet_connection": "No Internet connection",
  "ifood_portal_orders": "Cloud-contracted couriers via iFood",
  "print_cash_report": "Print Cash Report",
  "cashier_open": "Cashier Open",
  "product_type": "Product Type",
  "bulk": "Bulk",
  "unit": "Unit",
  "select_unit_measurement": "Select the unit of measurement",
  "kg_value": "Kilo value",
  "l_value": "Liter value",
  "barcode": "Barcode",
  "product_code": "Product code",
  "no_product_code": "No Product Code",
  "product_code_abbreviation": "Prod. Code",
  "product_code_already_exists": "There is already a product registered with this code.",
  "pizza_product_code_already_exists": "Unable to save: a product or pizza size already uses this code.",
  "volume": "Volume",
  "weight": "Weight",
  "kg_or_l": "kg or L",
  "select_product_will_be_sold": "Select whether the product will be sold as standard or in bulk",
  "automatic_confirmation": "Automatic confirmation",
  "manual_confirmation": "Manual confirmation",
  "unit_value": "Unit Price",
  "alter_value": "Price Change",
  "open_for_appointments": "Open for appointments",
  "closed_for_appointments": "Closed for appointments",
  "open_for_package": "Open for package",
  "closed_for_package": "Closed for package",
  "whatsMenuPro": {
    "this_app_is_better_than": "This APP is better than employees whether in-store or for delivery, all management is now automated!",
    "waiter_app_delivery": "WAITER APP, DELIVERY ROUTE, AND MUCH MORE.",
    "yes_i_want": "YES, I WANT MORE INFORMATION",
    "i_want_information": "I WANT INFORMATION!",
    "aprroved_by": "Approved by over",
    "restaurants_worldwide": "restaurants worldwide",
    "more_professionalism": "More professionalism",
    "more_clients_sales": "More clients and more sales...",
    "whatsMenuPro_transform_small": "WhatsMenu.PRO transforms small restaurants into powerful sales machines:",
    "receive_orders_auto": "Receive orders automatically without interacting with customers.",
    "customers_will_not": "Customers will no longer have to wait for the attendant.",
    "no_extra_labor": "No extra labor required to take orders.",
    "automatic_priting": "Automatic printing of orders.",
    "never_lose_order": "Never lose an order again.",
    "reduce_to_zero": "Reduce order errors to zero.",
    "increase_the_average": "Increase the average ticket and purchase frequency.",
    "control_everything": "Control everything automatically on your phone or computer.",
    "the_features": "The features you'll receive.",
    "the_most_complet": "A mais completa e poderosa Plataforma de Restaurantes:",
    "virtual_attendant": "Virtual Attendant",
    "catalog_mode": "Catalog Mode",
    "orders_delivery_scheduling": "Orders, Delivery Scheduling",
    "counter_orders": "Counter orders",
    "order_manager": "Order Manager",
    "pos_point_of_sale": "POS - Point of Sale",
    "reports_customers": "Reports: Customers, Products, Revenue, Inventory",
    "qr_code_table_delivery": "QR Code for Table, Delivery, and Counter",
    "free_website": "Free Professional Website",
    "app_waiter": "APP Waiter",
    "delivery_manager": "Delivery manager",
    "automatic_inventory_control": "Automatic Inventory Control",
    "domain_hosting": "Domain hosting",
    "talk_to_attendant": "TALK TO THE ATTENDANT",
    "those_who_use": "Those who use it recommend",
    "see_the_models": "See the models and place",
    "test_order": "a test oder.",
    "talk_with_attendant": "Talk with the attendant",
    "still_afraid": "But I'm still afraid",
    "wont_work": "it won't work, what now?",
    "we_have_human_team": "We have a 100% human team, highly trained to help you with these first steps, and whenever you need. We will schedule an onboarding video call and assist you with the settings. We'll guide you every step of the way!",
    "yes_i_wanna_help": "YES, I WANT HELP",
    "days_of_satisfaction": "7 days of satisfaction",
    "or_your_money_back": "or your money back!",
    "i_belive_in_the_results": "I believe so much in the results that the WhatsMenu.PRO platform will bring you that I offer a 7-day guarantee for you to try it out. If you're not satisfied with the results or if you regret it for any other reason, just contact me on WhatsApp, and I'll refund 100% of your money.",
    "talk_with_us_on_WhatsApp": "Talk with us on WhatsApp",
    "what_is_your_name": "What is your name?",
    "what_is_your_WhatsApp": "What is your WhatsApp?",
    "what_product_you_sell": "What product do you sell?",
    "Browse": "Navegue",
    "how_works": "HOW IT WORKS",
    "features": "FEATURES",
    "clients": "CLIENTS",
    "examples": "EXAMPLES",
    "team": "TEAM",
    "support": "SUPPORT",
    "access_dashboard": "ACCESS DASHBOARD",
    "right_reserved": "All rights reserved.",
    "digital_menu": "DIGITAL MENU",
    "delivery": "DELIVERY",
    "call": "CALL NOW!",
    "sounds_notification": "Order notification sound",
    "play_sound_delivery": "Enable delivery sound",
    "play_sound_table": "Enable table order sound"
  },
  "last_name": "Sobrenome",
  "secret_number": "CPF",
  "enter_motoboys_secret_number": "Enter motoboys sercret number",
  "enter_your_last_name": "Insira seu Sobrenome",
  "invalid_cpf": "CPF inválido",
  "printers": "Printers",
  "view": "View",
  "reload": "Reload",
  "force_reload": "Force Reload",
  "console": "Console",
  "print_auto": "Print Automatically",
  "custom": "Custom",
  "no_margin": "No Margin",
  "minimum_margin": "Minimum Margin",
  "scale": "Scale",
  "scale_print": "Print Scale",
  "scale_percentage": "Scale in percentage",
  "add_printer": "Add Printer",
  "printers_available": "Available Printers",
  "no_printer_available": "No Printers Available",
  "select_printer": "Select Printer",
  "select_printer_detail": "Select Printer, if you don't want auto print uncheck the box \"Print Automatically\"",
  "paper_size": "Paper Size",
  "select_paper_size": "Select Paper Size",
  "legacy_printer": "Legacy Print",
  "config_ambient_printer": "Configure Printing Environments",
  "paper_width": "Paper Width",
  "paper_width_detail": "Value in millimeters (mm)",
  "copies_quantity": "Copies Quantity",
  "dashboard": "Dashboard",
  "whatsapp_bot": "WhatsApp Bot",
  "disabled_menu": "Menu Disabled — Please contact the Establishment.",
  "login": "Login",
  "forgot_password": "Forgot my password",
  "logout": "Logout",
  "pos_videos": "POS Videos",
  "download_desktop_title": "Download the NEW WhatsMenu Desktop now",
  "download_desktop_subtitle": "Less Work and More Sales",
  "download_desktop_bot": "Virtual assistant for WhatsApp",
  "download_desktop_fidelity": "Loyalty Program",
  "download_desktop_cashback": "CashBack",
  "download_desktop_first_coupon": "First Purchase Coupon",
  "download_desktop_sales_bot": "Automated Sales Bot",
  "download_desktop_no_tabs": "Status sending without opening tabs",
  "download_app": "Download App",
  "how_to_use": "See How to Use",
  "invoice_available": "Monthly invoice available for payment! Click here.",
  "payment_overdue": "Your menu may be blocked because your monthly payment is overdue! Click here.",
  "tables_link": "Tables Link",
  "update_desktop_title": "New WhatsMenu Desktop",
  "update_desktop_message": "Lighter and faster — Greater efficiency in message controls.",
  "update_desktop_button": "UPDATE NOW",
  "bot_step1": "Open WhatsApp on your phone.",
  "bot_step2.1": "Tap",
  "bot_step2.2": "More options",
  "bot_step2.3": "on Android or",
  "bot_step2.4": "Settings",
  "bot_step2.5": "on iPhone.",
  "bot_step3.1": "Tap",
  "bot_step3.2": "Linked devices",
  "bot_step3.3": "and then",
  "bot_step3.4": "Link a device.",
  "bot_step4": "Point your phone at this screen to scan the QR code.",
  "connected": "Connected",
  "disconnected": "Disconnected",
  "connection_error": "Connection error",
  "disconnect": "Disconnect",
  "try_again": "Try again",
  "customer_service_bot": "Customer Service Bot",
  "bot_attention": "ATTENTION!",
  "phone_sync_warning": "Keep your phone screen open until the synchronization screen closes automatically!",
  "loading_messages": "Loading messages...",
  "print_env_config": "Print Environment Configuration",
  "print_env_edit": "Edit Print Environments",
  "print_type": "Print Type",
  "fiscal_printer": "Fiscal Printing",
  "production_printer": "Order Production Printing",
  "env_name": "Environment Name",
  "enter_env_name": "Enter the environment name",
  "prod_categories": "Product Categories",
  "select_prod_category": "Select the product categories to include in the print.",
  "save_edit": "Save Edit",
  "environment": "Environment",
  "print_env": "Print Environment",
  "env_register": "Register Environment",
  "printer_config": "Configure Printers",
  "edit_envs": "Edit Environments of",
  "print_envs": "Print Environments",
  "select_envs": "Select the environments you want to assign to",
  "bot_send_menu": "Menu sent by the bot",
  "bot_not_allow_attendant": "Do not allow contact with an attendant",
  "selected_item": "Selected item",
  "selected_items": "Selected items",
  "canceled_items": "Canceled items",
  "select_state": "Select State",
  "enter_the_address_number": "Ingrese el número de la dirección",
  "call": "CALL NOW!",
  "check_code": "Check the NPA",
  "cpf_cnpj_on_the_receipt": "CPF/CNPJ on the receipt",
  "cpf_invalid": "Invalid CPF",
  "denmark": "Denmark (kr)",
  "english_ie": "English (Ireland)",
  "finland": "Finland (€)",
  "france": "France (€)",
  "germany": "Germany (€)",
  "italy": "Italy (€)",
  "logistics_management": "Logistics Management",
  "logistics_description": "Eliminate delays and route errors, track all your couriers in real time on the GPS map, and deliver an exclusive experience in your customers' orders.",
  "logistics_mottu": "Fast and secure deliveries",
  "Nenhum garçom ativo": "View Menu",
  "norway": "Norway (kr)",
  "now_accepting_scheduled_orders": "Now accepting scheduled orders",
  "spain": "Spain (€)",
  "support": "Support",
  "sweden": "Sweden (kr)",
  "switzerland": "Switzerland (CHF)",
  "AF": "Afghanistan",
  "AX": "Åland Islands",
  "AL": "Albania",
  "DZ": "Algeria",
  "AS": "American Samoa",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarctica",
  "AG": "Antigua and Barbuda",
  "AR": "Argentina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AC": "Ascension Island",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbaijan",
  "BS": "Bahamas",
  "BH": "Bahrain",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Belarus",
  "BE": "Belgium",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BT": "Bhutan",
  "BO": "Bolivia",
  "BA": "Bosnia and Herzegovina",
  "BW": "Botswana",
  "BR": "Brazil",
  "IO": "British Indian Ocean Territory",
  "BN": "Brunei",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Cambodia",
  "CM": "Cameroon",
  "CA": "Canada",
  "CV": "Cape Verde",
  "KY": "Cayman Islands",
  "CF": "Central African Republic",
  "TD": "Chad",
  "CL": "Chile",
  "CN": "China",
  "CX": "Christmas Island",
  "CC": "Cocos (Keeling) Islands",
  "CO": "Colombia",
  "KM": "Comoros",
  "CG": "Congo",
  "CD": "Democratic Republic of the Congo",
  "CK": "Cook Islands",
  "CR": "Costa Rica",
  "CI": "Ivory Coast",
  "HR": "Croatia",
  "CU": "Cuba",
  "CY": "Cyprus",
  "CZ": "Czech Republic",
  "DK": "Denmark",
  "DJ": "Djibouti",
  "DM": "Dominica",
  "DO": "Dominican Republic",
  "EC": "Ecuador",
  "EG": "Egypt",
  "SV": "El Salvador",
  "GQ": "Equatorial Guinea",
  "ER": "Eritrea",
  "EE": "Estonia",
  "SZ": "Eswatini",
  "ET": "Ethiopia",
  "FK": "Falkland Islands",
  "FO": "Faroe Islands",
  "FJ": "Fiji",
  "FI": "Finland",
  "FR": "France",
  "GF": "French Guiana",
  "PF": "French Polynesia",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Georgia",
  "DE": "Germany",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Greece",
  "GL": "Greenland",
  "GD": "Grenada",
  "GP": "Guadeloupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guinea",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "HT": "Haiti",
  "VA": "Vatican City",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hungary",
  "IS": "Iceland",
  "IN": "India",
  "ID": "Indonesia",
  "IR": "Iran",
  "IQ": "Iraq",
  "IE": "Ireland",
  "IM": "Isle of Man",
  "IL": "Israel",
  "IT": "Italy",
  "JM": "Jamaica",
  "JP": "Japan",
  "JE": "Jersey",
  "JO": "Jordan",
  "KZ": "Kazakhstan",
  "KE": "Kenya",
  "KI": "Kiribati",
  "KP": "North Korea",
  "KR": "South Korea",
  "XK": "Kosovo",
  "KW": "Kuwait",
  "KG": "Kyrgyzstan",
  "LA": "Laos",
  "LV": "Latvia",
  "LB": "Lebanon",
  "LS": "Lesotho",
  "LR": "Liberia",
  "LY": "Libya",
  "LI": "Liechtenstein",
  "LT": "Lithuania",
  "LU": "Luxembourg",
  "MO": "Macau",
  "MG": "Madagascar",
  "MW": "Malawi",
  "MY": "Malaysia",
  "MV": "Maldives",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Marshall Islands",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MU": "Mauritius",
  "YT": "Mayotte",
  "MX": "Mexico",
  "FM": "Micronesia",
  "MD": "Moldova",
  "MC": "Monaco",
  "MN": "Mongolia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MA": "Morocco",
  "MZ": "Mozambique",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Netherlands",
  "NC": "New Caledonia",
  "NZ": "New Zealand",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Norfolk Island",
  "MK": "North Macedonia",
  "MP": "Northern Mariana Islands",
  "NO": "Norway",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Palestine",
  "PA": "Panama",
  "PG": "Papua New Guinea",
  "PY": "Paraguay",
  "PE": "Peru",
  "PH": "Philippines",
  "PN": "Pitcairn Islands",
  "PL": "Poland",
  "PT": "Portugal",
  "PR": "Puerto Rico",
  "QA": "Qatar",
  "RE": "Réunion",
  "RO": "Romania",
  "RU": "Russia",
  "RW": "Rwanda",
  "BL": "Saint Barthélemy",
  "SH": "Saint Helena",
  "KN": "Saint Kitts and Nevis",
  "LC": "Saint Lucia",
  "MF": "Saint Martin",
  "PM": "Saint Pierre and Miquelon",
  "VC": "Saint Vincent and the Grenadines",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "São Tomé and Príncipe",
  "SA": "Saudi Arabia",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapore",
  "SX": "Sint Maarten",
  "SK": "Slovakia",
  "SI": "Slovenia",
  "SB": "Solomon Islands",
  "SO": "Somalia",
  "ZA": "South Africa",
  "GS": "South Georgia and the South Sandwich Islands",
  "SS": "South Sudan",
  "ES": "Spain",
  "LK": "Sri Lanka",
  "SD": "Sudan",
  "SR": "Suriname",
  "SJ": "Svalbard and Jan Mayen",
  "SE": "Sweden",
  "CH": "Switzerland",
  "SY": "Syria",
  "TW": "Taiwan",
  "TJ": "Tajikistan",
  "TZ": "Tanzania",
  "TH": "Thailand",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad and Tobago",
  "TN": "Tunisia",
  "TR": "Turkey",
  "TM": "Turkmenistan",
  "TC": "Turks and Caicos Islands",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ukraine",
  "AE": "United Arab Emirates",
  "GB": "United Kingdom",
  "US": "United States",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "VG": "British Virgin Islands",
  "VI": "United States Virgin Islands",
  "WF": "Wallis and Futuna",
  "EH": "Western Sahara",
  "YE": "Yemen",
  "ZM": "Zambia",
  "ZW": "Zimbabwe",
  "highlight_products": "Featured products",
  "highlight_description": "Check out our most popular products!",
  "highlights": "Highlights",
  "highlight_successfuly_updated": "Highlight successfully updated!",
  "highlight_category": "Featured product category",
  "highlight_explanation": "Products marked with a star will be highlighted in your WhatsMenu store!",
  "complete_category": "Complete category",
  "fees_settings": "Fees Settings",
  "cashback_why_better": "Why cashback outperforms traditional promotions and portal ads",
  "cashback_money_attractive": "Money is more attractive than points",
  "cashback_defined_validity": "Defined validity",
  "cashback_controlled_cost": "Controlled cost",
  "cashback_total_automation": "Total automation",
  "cashback_rewards_now": "Cashback rewards the now. The customer returns because they feel they've already won and can't lose the money.",
  "cashback_growth_impact": "Growth and Real Impact on Average Ticket and Frequency",
  "cashback_how_to_activate": "HOW TO ACTIVATE THIS FEATURE:",
  "cashback_set_percentage": "Set the percentage",
  "cashback_choose_validity": "Choose the validity",
  "cashback_activate_save": "Activate and save",
  "dashboard_auto_assign": "Automatic coupon",
  "congrats_auto_assign": "🎉 CONGRATULATIONS! You got",
  "auto_assign_discount": "off!",
  "store_auto_assign_1": "Add",
  "store_auto_assign_2": "more to get",
  "price_from": "Was:",
  "price_to": "Now:",
  "progressive_discount": "Progressive Discount",
  "progressive_discounts": "Progressive Discounts",
  "progressive_discount_manager": "Progressive Discount Management",
  "discounts": "Discounts",
  "discount_status": "Discount status",
  "delete_discount": "Delete discount",
  "delete_discount_confirm": "Are you sure you want to delete the discount?",
  "discount_not_created": "Discount not created",
  "discount_not_created_desc": "It was not possible to create the discount",
  "discount_name": "Discount name",
  "discount_already_exists": "Discount already exists",
  "discount_invalid_chars": "Special characters are not allowed",
  "discount_allowed_chars_hint": "Only letters, numbers, hyphen (-) and underscore (_)",
  "discount_code_valid": "Name available",
  "applied_discount": "Discount applied",
  "invalid_coupon": "The coupon is not valid!",
  "select_your_discount": "Select your discount",
  "check_for_updates": "Check for updates",
  "update_alert": "Update alert",
  "update_unavailable": "No updates available.",
  "configure_extra_fees": "Configure additional service or transfer fees below. These fees will be charged to your customer at the end of each order. E.g.: cover charge, valet, waiter service, service fee or tax.",
  "fees_already_exists": "A fee with this name already exists.",
  "fees_name_cannot_be_empty": "Fee name cannot be empty.",
  "fees_name_too_long": "Fee name cannot be longer than 20 characters.",
  "fees_min_value": "Enter a value greater than {{value}}",
  "fees_created": "Fee {{code}} created successfully",
  "fees_updated": "{{code}} updated successfully.",
  "fees_deleted": "Fee {{code}} deleted successfully",
  "highlight_limit": "You can have a maximum of 10 highlighted products.",
  "consider_current_value": "If any value has been changed, the current value will be considered",
  "unavailable_products": "Unavailable products",
  "unavailable_products_desc": "The following products and/or their add-ons are unavailable",
  "continue_anyway": "Continue anyway",
  "total_clients": "Total Clients",
  "inactive_30d": "Inactive for +30 days",
  "new_clients": "New Clients",
  "last_order": "Last Order",
  "favorite_product": "Favorite Product",
  "segment": "Segment",
  "inactive_client": "Inactive",
  "new_client": "New",
  "recurring_client": "Recurring",
  "loyal_client": "Loyal",
  "days_ago": "{{count}}d ago",
  "days_without_order": "{{count}}d without ordering",
  "segments": "Segments",
  "clear_filters": "Clear filters",
  "inactive_days_label": "No order for (days)",
  "min_ticket_label": "Min. ticket",
  "max_ticket_label": "Max. ticket",
  "client_analysis": "Client Analysis",
  "cancellation_rate": "Cancellation Rate",
  "mom_change": "MoM Change",
  "biggest_order": "Biggest Order",
  "smallest_order": "Smallest Order",
  "most_ordered_products": "Most Ordered Products",
  "no_data": "No data",
  "monthly_frequency": "Monthly Frequency",
  "trend_up": "↑ growing",
  "trend_down": "↓ declining",
  "trend_stable": "→ stable",
  "avg_ticket_by_month": "Average Ticket by Month",
  "preferred_order_days": "Preferred Order Days",
  "repurchase_interval": "Repurchase Interval",
  "average": "Average",
  "median": "Median",
  "samples": "Samples",
  "requires_at_least_2_orders": "At least 2 orders required",
  "export_csv": "Export CSV",
  "no_client_found_by_name": "No client found with that name",
  "based_on_last_orders": "Based on the last {{count}} of {{total}} orders",
  "segment_inactive_15d": "Inactive 15d",
  "segment_inactive_30d": "Inactive 30d",
  "segment_inactive_60d": "Inactive 60d",
  "segment_new_1_order": "New (1 order)",
  "segment_high_ticket": "High ticket",
  "back_to_list_detail": "← Back to list",
  "highlight": "Highlight",
  "trend": "Trend",
  "weighted_average": "Weighted Average",
  "intervals": "Intervals",
  "low_confidence_sample": "⚠ low sample",
  "intervals_in_range": "interval(s) in this range",
  "ticket_label": "Ticket",
  "total_label": "Total",
  "no_orders_this_month": "No orders this month",
  "block_date": "Block Date",
  "payment_date": "Payment Date",
  "cmv_report_title": "COGS Report",
  "cmv_health_score": "Health Score",
  "cmv_alert_critical": "products with critical COGS!",
  "cmv_alert_critical_desc": "Products with COGS above 35% hurt profitability.",
  "cmv_alert_potential_savings": "Potential savings per unit:",
  "cmv_alert_priority_products": "Priority products for review:",
  "cmv_coverage_title": "Cost coverage:",
  "cmv_coverage_desc": "products without registered cost. Register costs for complete analysis and accurate decisions.",
  "cmv_success_title": "Excellent! Your pricing is healthy",
  "cmv_success_desc": "No products with critical COGS. Keep monitoring regularly.",
  "cmv_avg": "Average COGS",
  "cmv_very_high": "Very High COGS",
  "cmv_ideal": "Ideal COGS",
  "cmv_very_low": "Very Low",
  "cmv_no_cost": "No Cost",
  "cmv_urgent_action": "Urgent action",
  "cmv_perfect": "Perfect",
  "cmv_register_costs": "Register costs",
  "cmv_see_products": "See products",
  "cmv_search_product": "Search Product",
  "cmv_search_placeholder": "Name or category...",
  "cmv_category": "Category",
  "cmv_all_categories": "All",
  "cmv_type": "Type",
  "cmv_delivery": "Delivery",
  "cmv_table": "Table",
  "cmv_status": "COGS Status",
  "cmv_all_status": "All",
  "cmv_export_excel": "Export Excel",
  "cmv_showing": "Showing",
  "cmv_of": "of",
  "cmv_products": "products",
  "cmv_with_costs": "with registered costs",
  "cmv_how_to_interpret": "How to interpret COGS:",
  "cmv_very_high_desc": "Cost too high. Negotiate suppliers or adjust price.",
  "cmv_ideal_desc": "Healthy profitability range.",
  "cmv_very_low_desc": "High margin. Consider promotional strategies.",
  "cmv_updated_at": "Updated at:",
  "cmv_loading": "Loading COGS analysis...",
  "cmv_product": "Product",
  "cmv_sale_price": "Selling Price",
  "cmv_cost": "Cost",
  "cmv_no_products_found": "No products found with the applied filters",
  "cmv_no_products_yet": "No products registered yet",
  "cmv_clear_filters": "Clear filters",
  "cmv_disclaimer_1": "COGS (Cost of Goods Sold) represents only direct acquisition/production costs.",
  "cmv_disclaimer_2": "Taxes, fees, shipping, packaging, and fixed costs (rent, utilities) are not included in this calculation.",
  "cmv_insight_title": "COGS Analysis",
  "cmv_insight_delivery": "Delivery",
  "cmv_insight_table": "Table",
  "cmv_insight_margin": "Margin",
  "cmv_insight_profit_per_sale": "Profit per sale",
  "cmv_insight_status_critical": "Critical COGS!",
  "cmv_insight_status_high": "High COGS",
  "cmv_insight_status_ideal": "Ideal COGS",
  "cmv_insight_status_low": "Very Low COGS",
  "cmv_insight_suggestion_critical": "Renegotiate suppliers or increase price",
  "cmv_insight_suggestion_high": "Consider adjusting cost or selling price",
  "cmv_insight_suggestion_ideal": "Healthy margin! Keep monitoring",
  "cmv_insight_suggestion_low": "Great margin! Consider promotions",
  "cmv_insight_enter_cost": "Enter cost to see analysis",
  "cmv_insight_enter_price": "Enter price to see analysis",
  "eat_on_site": "Eat on site",
  "eat_on_local_subtitle": "Consumption on place, no delivery or packaging fees",
  "Can_the_customer_eat_here": "The customer can order to eat on site",
  "cart_type": "Order type",
  "eat_here": "I will eat on site",
  "flavor_badge_configure": "Configure Badge",
"flavor_badge_text_label": "Badge Text",
"flavor_badge_text_placeholder": "E.g.: New, Most ordered",
"flavor_badge_color_label": "Badge Color",
"flavor_badge_color_hint": "Choose background color",
"flavor_badge_name_fallback": "Flavor Name",
"flavor_badge_description_fallback": "Your description here...",
"flavor_badge_preview_alt": "Preview",
"flavor_badge_remove": "Remove badge",
"flavor_badge_add": "+ badge",
  "table_quick_search": "Quick search",
"table_search_placeholder": "Table, number or waiter",
"table_status_filter_label": "Table status",
"table_filter_all": "All",
"table_filter_open": "Open",
"table_filter_closed": "Closed",
"table_payment_filter_label": "Payment",
"filter_all": "All",
"payment_status_paid": "Paid",
"payment_status_partial": "Partial",
"payment_status_pending": "Pending",
"table_waiter_filter_label": "Waiter",
"table_open_badge": "Open",
"table_closed_badge": "Closed",
"table_orders_pending_tooltip": "{{count}} order(s) waiting",
"table_order_singular": "order",
"table_order_plural": "orders",
"table_orders_cancelled": "cancelled",
"table_open_duration": "open for {{hours}}h{{minutes}}min",
"table_closed_duration": "was open for {{hours}}h{{minutes}}min",
"table_no_time": "no time available",
"table_waiter_name_label": "Waiter:",
"payment_cleared": "Payment cleared",
"payment_partial_label": "Partial payment",
"payment_pending_label": "Payment pending",
"table_total_value_label": "Total:",
"nfe_emitted_tooltip": "NFC-e has been issued",
"nfe_emit_tooltip": "Issue NFC-e",
"nfe_no_eligible_orders": "No eligible orders for issuance",
"nfe_close_table_first": "Close the table to issue NFC-e",
"nfe_emitted_alt": "NFC-e issued for table",
"nfe_emit_table_alt": "Issue NFC-e for Table",
"nfe_blocked_alt": "NFC-e blocked",
"table_paid_label": "Paid:",
"table_due_label": "Due:",
"table_fixed_fee_label": "Fixed fee:",
"table_percentage_fee_label": "Percentage fee:",
"table_print_col": "Print",
"table_order_code_col": "Order Code",
"table_name_col": "Name",
"table_total_col": "Total",
"table_time_col": "Time",
"table_status_col": "Status",
"table_served_status": "Served",
"table_fees_footer": "Fees: +{{fixed}} / +{{percentage}}%",
"table_total_footer_label": "Table total:",
"table_no_results": "No tables found for the applied filters.",
"table_name_fallback": "Table #{{id}}",
"table_payment_not_informed": "Not informed",
"delivery_person_signed_successfully": "Delivery driver signed successfully",
"icon_category": "Category Icon",
"icon_category_optional": "Category icon (optional)",
"edit_order": "edit order",
"editing_ongoing": "Editing in Progress",
"cancelled_parentheses": "(CANCELLED)",
"news": "News",
"cashback_message": "You generated R$ {{cartTotalCashback}} in sales, driven by R$ {{cartTotalCashbackValue}} in cashback.",
"group_fees": "Group Fees",
"technical_support": "Technical Support",
"everyday": "Monday to Sunday",
  "dashboard_title": "Dashboard",
  "dashboard_business_summary": "Business Summary",
  "dashboard_overview": "Overview",
  "dashboard_overview_title": "Your restaurant at a glance",
  "dashboard_overview_hint": "Click any chart to open detailed insights.",
  "dashboard_cache_valid": "cache valid",
  "dashboard_cache_expired": "cache expired",
  "dashboard_loading_report": "Loading analytics report...",
  "dashboard_load_error": "Unable to load analytics data.",
  "dashboard_period_prefix": "Track your restaurant's performance for the period from",
  "dashboard_period_to": "to",
  "dashboard_next_update": "Next update",
  "dashboard_status_orders": "Order Status",
  "dashboard_approved": "Approved",
  "dashboard_preparing": "Preparing",
  "dashboard_in_delivery": "Out for delivery",
  "dashboard_delivered": "Delivered",
  "dashboard_cancelled": "Cancelled",
  "dashboard_top_deliverers": "Top delivery drivers",
  "dashboard_deliveries_in_period": "Deliveries in the period",
  "dashboard_no_data_period": "No data for this period.",
  "dashboard_cash_and_goals": "Cash Flow & Goals",
  "dashboard_opening": "Opening balance",
  "dashboard_entries": "Income",
  "dashboard_outflows": "Expenses",
  "dashboard_current_balance": "Current balance",
  "dashboard_monthly_goal": "Monthly goal",
  "dashboard_current": "Current",
  "dashboard_goal": "Goal",
  "dashboard_progress": "Progress",

  "chart_insights_default_title": "Chart Insights",
  "chart_insights_default_subtitle": "Contextual analysis of data and correlations.",
  "chart_insights_close_panel": "Close panel",
  "chart_insights_empty_state": "Not enough insights for this chart in the selected period.",
  "chart_insights_next_step": "Next step",

  "insight_tone_critical": "CRITICAL",
  "insight_tone_attention": "ATTENTION",
  "insight_tone_info": "INFO",
  "insight_tone_success": "SUCCESS",
  "insight_tone_opportunity": "OPPORTUNITY",
  "insight_tone_analysis": "ANALYSIS",

  "analytics_action_adjust_menu": "Adjust menu",
  "analytics_action_campaigns": "Campaigns",
  "analytics_action_configure_cashback": "Configure cashback",
  "analytics_action_configure_coupons": "Configure coupons",
  "analytics_action_configure_payments": "Configure payments",
  "analytics_action_create_conversion_coupon": "Create conversion coupon",
  "analytics_action_create_coupon": "Create coupon",
  "analytics_action_create_first_purchase_coupon": "Create first-purchase coupon",
  "analytics_action_create_hour_promotion": "Create time-based promotion",
  "analytics_action_create_promotion": "Create promotion",
  "analytics_action_follow_deliveries": "Track deliveries",
  "analytics_action_follow_map": "Track map",
  "analytics_action_manage_campaigns": "Manage campaigns",
  "analytics_action_open_orders": "Open orders",
  "analytics_action_view_campaigns": "View campaigns",
  "analytics_action_view_cash": "View cash flow",
  "analytics_action_view_coupons": "View coupons",
  "analytics_action_view_order_channels": "View orders by channel",
  "analytics_action_view_order_map": "View order map",
  "analytics_action_view_orders": "View orders",

  "analytics_campaign_efficiency_message": "Leading campaign {{code}} with {{roi}}x ROI and a return of {{value}}.",
  "analytics_campaign_efficiency_message_none": "Not enough campaigns to rank coupon returns.",
  "analytics_campaign_efficiency_next": "Scale the campaign with the highest ROI and pause campaigns below the minimum threshold.",
  "analytics_campaign_efficiency_title": "Campaign financial efficiency",

  "analytics_category_finance": "Finance",
  "analytics_category_marketing": "Marketing",
  "analytics_category_operations": "Operations",
  "analytics_category_relationship": "Customer Relations",

  "analytics_channel_conversion_message": "Conversion to delivered orders is {{value}}. Higher-volume channels need a more predictable flow to avoid increasing losses.",
  "analytics_channel_conversion_next": "Compare cancellations by order type and prioritize adjustments on the channel with the most friction.",
  "analytics_channel_conversion_title": "Channel and final conversion",

  "analytics_chart_clients_title": "Customer Insights",
  "analytics_chart_location_title": "Location Insights",

  "analytics_conversion_revenue_message": "The delivered-order funnel rate is {{value}}. Improving the final stages impacts revenue without increasing acquisition costs at the same level.",
  "analytics_conversion_revenue_next": "Address the statuses with the longest queues and reduce the time between preparation and delivery.",
  "analytics_conversion_revenue_title": "Revenue depends on final conversion",

  "analytics_coupon_dependency_message": "{{value}} of orders use a coupon. This indicator should grow together with ROI, not just volume.",
  "analytics_coupon_dependency_message_none": "There are not enough orders to measure coupon dependency.",
  "analytics_coupon_dependency_next": "Set a daily usage limit and replace part of the discounts with strategic delivery incentives.",
  "analytics_coupon_dependency_title": "Discount dependency on order volume",

  "analytics_customer_retention_message": "There are {{recurring}} returning customers compared to {{new}} new customers during the period.",
  "analytics_customer_retention_message_none": "Not enough customer data to calculate retention.",
  "analytics_customer_retention_next": "Run a repurchase campaign for new customers within 7 days of their first order.",
  "analytics_customer_retention_title": "Customer retention at {{value}}",

  "analytics_delivery_capacity_message_active": "Cross-referencing peak hours with delivery driver staffing helps reduce queues and cycle time.",
  "analytics_delivery_capacity_message_none": "No delivery drivers were mapped during the period, reducing operational traceability.",
  "analytics_delivery_capacity_next_active": "Adjust the schedules of top delivery drivers to cover the highest-demand period.",
  "analytics_delivery_capacity_next_none": "Validate the delivery driver integration and ensure motoboyId is populated in orders.",
  "analytics_delivery_capacity_title": "Delivery capacity during peak pressure",

  "analytics_demand_redistribution_message": "Coupon usage in {{value}} of orders can be used to shift demand to off-peak hours without reducing overall margin.",
  "analytics_demand_redistribution_next": "Create an off-peak campaign with a daily limit and monitor average order value.",
  "analytics_demand_redistribution_title": "Redistribute demand with controlled incentives",

  "analytics_faturamento_meta_achieved": "The monthly goal has been reached based on current revenue.",
  "analytics_faturamento_meta_missing": "At the current pace, {{value}} is still needed to reach the goal.",
  "analytics_faturamento_meta_next_achieved": "Set a new incremental goal for the next cycle while preserving margin.",
  "analytics_faturamento_meta_next_missing": "Strengthen campaigns during periods with better conversion and higher average order value.",
  "analytics_faturamento_meta_title": "Monthly goal at {{value}}",

  "analytics_geographic_demand_message": "{{city}} represents {{value}} of orders with location data.",
  "analytics_geographic_demand_message_none": "Not enough data to identify geographic concentration.",
  "analytics_geographic_demand_next": "Create city-specific campaigns with a budget proportional to volume and expansion potential.",
  "analytics_geographic_demand_title": "Geographic concentration of demand",

  "analytics_insights_auto_subtitle": "Automatic insights combining KPIs, funnel data, coupons, and operations.",

  "analytics_margin_coupon_message": "With {{value}} of orders using coupons, monitoring margin by discounted product helps prevent growth from eroding profit.",
  "analytics_margin_coupon_next": "Create coupon rules that prioritize higher-margin items to protect profitability.",
  "analytics_margin_coupon_title": "Margin and coupon dependency",

  "analytics_metric_active_deliverers": "Active delivery drivers",
  "analytics_metric_average_roi": "Average ROI",
  "analytics_metric_average_ticket": "Average order value",
  "analytics_metric_avg_7d_current": "Current 7-day average",
  "analytics_metric_avg_7d_previous": "Previous 7-day average",
  "analytics_metric_cancelled": "Cancellations",
  "analytics_metric_conversion_rate": "Conversion rate",
  "analytics_metric_coupon_investment": "Coupon investment",
  "analytics_metric_coupon_return": "Coupon return",
  "analytics_metric_coupon_usage": "Coupon usage",
  "analytics_metric_coupons_used": "Coupons used",
  "analytics_metric_current_revenue": "Current revenue",
  "analytics_metric_delivered": "Delivered",
  "analytics_metric_delivery": "Delivery",
  "analytics_metric_funnel_conversion": "Funnel conversion",
  "analytics_metric_in_delivery_now": "Currently out for delivery",
  "analytics_metric_items_margin_below_20": "Items with margin < 20%",
  "analytics_metric_leading_city": "Leading city",
  "analytics_metric_leading_city_orders": "Orders from leading city",
  "analytics_metric_leading_method": "Leading method",
  "analytics_metric_leading_neighborhood": "Leading neighborhood",
  "analytics_metric_leading_share": "Leading share",
  "analytics_metric_mapped_cities": "Mapped cities",
  "analytics_metric_month_goal": "Monthly goal",
  "analytics_metric_neighborhood_orders": "Orders in neighborhood",
  "analytics_metric_new_customers": "New customers",
  "analytics_metric_orders": "Orders",
  "analytics_metric_orders_in_period": "Orders in period",
  "analytics_metric_orders_peak": "Orders at peak",
  "analytics_metric_peak_hour": "Peak hour",
  "analytics_metric_pickup": "Pickup",
  "analytics_metric_preparing": "Preparing",
  "analytics_metric_recurring_customers": "Returning customers",
  "analytics_metric_revenue": "Revenue",
  "analytics_metric_revenue_variation": "Revenue variation",
  "analytics_metric_table": "Dine-in",
  "analytics_metric_top_product": "Top product",
  "analytics_metric_total_investment": "Total investment",
  "analytics_metric_total_orders": "Total orders",
  "analytics_metric_total_processed": "Total processed",
  "analytics_metric_total_product_profit": "Total product profit",
  "analytics_metric_total_return": "Total return",
  "analytics_metric_usage_rate": "Usage rate",

  "analytics_order_channel_mix_message": "Delivery represents {{delivery}}, pickup {{withdrawal}}, and dine-in {{table}}.",
  "analytics_order_channel_mix_message_none": "No order type data for the period.",
  "analytics_order_channel_mix_next": "Adjust operational capacity by channel to reduce service bottlenecks.",
  "analytics_order_channel_mix_title": "Order channel mix",

  "analytics_payment_concentration_message": "{{method}} represents {{value}} of the payment volume.",
  "analytics_payment_concentration_message_none": "Not enough payment data to identify concentration.",
  "analytics_payment_concentration_next_balanced": "Maintain a balanced mix and monitor cost per payment processor.",
  "analytics_payment_concentration_next_high": "Offer a lightly incentivized alternative to reduce dependency on a single payment method.",
  "analytics_payment_concentration_title": "Payment method concentration",

  "analytics_payment_mix_ticket_message": "With an average order value of {{value}}, the payment mix should be monitored alongside transaction costs to protect net margin.",
  "analytics_payment_mix_ticket_message_none": "Not enough orders to correlate average order value with payment mix.",
  "analytics_payment_mix_ticket_next": "Compare payment processing fees by method with the weekly average order value.",
  "analytics_payment_mix_ticket_title": "Payment mix and average order value",

  "analytics_peak_message_high": "High concentration in a single hour increases the risk of delays, stockouts, and a decline in customer experience.",
  "analytics_peak_message_none": "No hourly concentration detected during the current period.",
  "analytics_peak_next_high": "Open a reinforced shift 1 hour before and 1 hour after the peak and monitor delivery SLA.",
  "analytics_peak_next_none": "Collect more orders to establish an hourly demand pattern.",
  "analytics_peak_title": "Peak at {{hour}} accounts for {{value}}",

  "analytics_product_profit_message": "{{product}} accounts for {{value}} of the profit from leading products.",
  "analytics_product_profit_message_none": "Not enough data to assess profit concentration by product.",
  "analytics_product_profit_next": "Increase sales of high-margin products and review pricing for low-margin items.",
  "analytics_product_profit_title": "Profit concentration by product",

  "analytics_retention_growth_message": "Sustainable growth tends to combine new customer acquisition with increased repeat purchases and consistent average order value.",
  "analytics_retention_growth_next": "Segment new customers by neighborhood and time of day to improve second purchases.",
  "analytics_retention_growth_title": "Retention and revenue growth",

  "analytics_top_neighborhood_message": "{{neighborhood}} in {{city}} leads demand and should guide operational capacity and promised delivery times.",
  "analytics_top_neighborhood_message_none": "Not enough neighborhood data to suggest operational prioritization.",
  "analytics_top_neighborhood_next": "Review the delivery SLA in the leading neighborhood and create a local retention offer.",
  "analytics_top_neighborhood_title": "Most active neighborhood for prioritization",

  "analytics_trend_last_7d_message": "The recent daily average is {{value}} ({{delta}} vs. the previous 7 days).",
  "analytics_trend_last_7d_next": "Use the highest-revenue days to define the offer calendar and staffing.",
  "analytics_trend_last_7d_next_no_data": "Accumulate at least 14 days of data to enable robust trend comparisons.",
  "analytics_trend_last_7d_no_data": "There is not enough history yet to compare two 7-day windows.",
  "analytics_trend_last_7d_title": "Last 7 days trend"
}
